<template>
  <div>
    <div class="section" style="min-width: 1200px;">
      <!--      海创定制-->
      <div v-if="toExoSystemHc">
        <span class="title">{{ $t('CargoMsg.Cargo_VehicleInformation') }} <span v-if="!job.uuid" style="color: red; font-weight:lighter">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}</span> <span style="margin: 20px">{{ $t('CargoMsg.Cargo_DispatchVehicleNoteFields') }}</span>
          <span style="color: red; font-weight: bold">{{ $t('CargoMsg.Cargo_TTDEG') }}</span></span>
        <div style="display: flex;padding-bottom: 5px">
          <el-button no="addHcInfo" type="primary" :disabled="readonly || !job.uuid" @click="addHcInfoHandler">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="delHcInfo" :disabled="readonly || !job.uuid" type="danger" @click="delHcInfoHandler">{{ $t('SeaExport.Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          no="hcInfo"
          config-module="20250522"
          :grid-options="hcInfo.gridOptions"
          :grid-params.sync="hcInfo.gridParams"
          :column-defs="hcInfoColumnDef"
          :row-data="hcInfoTrucking"
          style="width:100%;padding-bottom: 5px"
          @gridReady="params=>{hcInfo.gridApi=params.api}"
        />
        <span class="title">{{ $t('Partners.doorInformation') }} </span>
        <div style="display: flex;padding-bottom: 5px;">
          <el-button no="addHcDoor" type="primary" :disabled="readonly || !job.uuid" @click="addHcDoorHandler(false)">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="delHcDoor" :disabled="readonly || !job.uuid" type="danger" @click="delHcDoorHandler">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="informationMaintenance" :disabled="readonly || !job.uuid" type="success" @click="addDoor">{{ $t('CargoMsg.Cargo_InformationMaintenance') }}</el-button>
        </div>
        <cargo-ag-grid
          no="hcInfo"
          config-module="20250523"
          :grid-options="hcDoor.gridOptions"
          :grid-params.sync="hcDoor.gridParams"
          :column-defs="hcDoorColumDef"
          :row-data="hcDoorTrucking"
          style="width:100%;"
          @gridReady="params=>{hcDoor.gridApi=params.api}"
        />
      </div>
      <!--      原页面-->
      <div v-if="!toExoSystemHc">
        <span class="title">{{ $t('SeaExport.DoorToDoorLoading') }} <span style="color: red; font-weight:lighter;margin:30px;">{{ $t('SeaExport.SaveBusinessBeforeEnterMultiGate') }}<!--{{$t('Message.MultiDoorsTip')}}--></span></span>
        <div style="display:flex;flex-direction:column">
          <div v-if="showSecondSync">
            <el-button type="primary" @click="syncToDischargingTruckingInfo">{{ $t('SeaExport.SecondarySynchronization') }}</el-button>
          </div>
          <div v-if="job.multiplePickups">
            <cargo-ag-grid
              v-if="top.visible"
              no="1"
              :config-module="topConfigModuel"
              :grid-options="top.gridOptions"
              :grid-params.sync="top.gridParams"
              :column-defs="topColumnDefs"
              :row-data="trucking"
              style="width:100%;"
              @gridReady="params=>{topgridApi=params.api}"
            />
          </div>
          <div v-if="job.multiplePickups" class="app-main-inner-row operations" style="padding:5px 0">
            <div v-show="cooperateEdit" class="triggers">
              <div>
                <el-button no="2" type="primary" :disabled="readonly" @click="copyNewHandler">{{ $t('SeaExport.copyAndAddPoItems') }}</el-button>
                <el-button no="3" type="primary" :disabled="readonly" @click="addHandler">{{ $t('SeaExport.Add2') }}</el-button>
                <el-button no="4" :disabled="!btnEnable.btDel " type="danger" @click="delHandler">{{ $t('SeaExport.Delete') }}
                </el-button>
              </div>
            </div>
          </div>
          <el-divider v-if="job.multiplePickups" />
          <el-form :inline="true" class="inline-form" label-width="100px" label-position="left">
            <el-form-item>
              <template>
                <el-checkbox v-model="job.multiplePickups" no="5.1" :disabled="readonly || action==='add'" style="width: auto;" @change="multiPickupsChangeHandler">{{
                  $t('SeaExport.MultiDoors') }}
                </el-checkbox>
                <el-checkbox v-if="job.lob==='SE' && multiTruckingShow" v-model="job.multipleCabinets" no="5.2" :disabled="readonly || action==='add'" style="width: auto;" @change="changePickupsOrCabinets('Cabinets')">
                  {{ $t('SeaExport.MultiCabinets') }}
                </el-checkbox>
                <br>
                <el-checkbox v-if="job.lob!=='SE'" v-model="truckingInfo.loadingPortService" no="loadingPortService" :disabled="readonly" style="width: auto;" @change="onLoadingPortServiceChange">
                  {{ $t('CargoMsg.Cargo_PortOfLoading') }}{{ $t('SeaExport.Service') }}
                </el-checkbox>
                <el-checkbox v-if="job.lob!=='SE'" v-model="truckingInfo.dischargingPortService" no="dischargingPortService" :disabled="readonly" style="width: auto;" @change="onDischargingPortServiceChange">
                  {{ $t('CargoMsg.Cargo_PortOfDischarge') }}{{ $t('SeaExport.Service') }}
                </el-checkbox>
              </template>
            </el-form-item>
          </el-form>
          <el-form v-if="job.multiplePickups||job.lob==='SE'||job.lob==='SI'||job.lob==='AI'" :inline="true" class="inline-form" label-width="100px" label-position="left">
            <el-form-item>
              <label style="width: 55px">{{ $t('SeaExport.Quantity') }}</label>
              <el-input-number
                no="6"
                :value="truckingInfo.quantity||undefined"
                :disabled="readonly"
                :min="0"
                :max="999999"
                :precision="0"
                controls-position="right"
                style="width: 118px"
                @input="val=>{truckingInfo.quantity=val}"
              />
              <label style="width: 55px">{{ $t('SeaExport.Weight') }}</label>
              <el-input-number
                no="7"
                :value="truckingInfo.weight||undefined"
                :disabled="readonly"
                :min="0"
                :max="999999"
                :precision="3"
                controls-position="right"
                style="width: 118px"
                @input="val=>{truckingInfo.weight=val}"
              />
              <label style="width: 55px">{{ $t('SeaExport.Cubage') }}</label>
              <el-input-number
                no="8"
                :value="truckingInfo.cubage||undefined"
                :disabled="readonly"
                :min="0"
                :max="999999"
                :precision="3"
                controls-position="right"
                style="width: 118px"
                @input="val=>{truckingInfo.cubage=val}"
              />
            </el-form-item>
            <el-form-item v-if="job.multiplePickups" label="S/O No." label-width="100px" class="custom" style="margin-left: 30px;">
              <so-no-selector v-model="truckingInfo.soNo" :so-no="soNo" :disabled="readonly" style="width:400px" />
            </el-form-item>
          </el-form>

          <div class="trucking-form">
            <el-form :disabled="readonly" label-width="140px" label-position="left">
              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageCompany')" class="custom">
                <cargo-company-select
                  no="9"
                  :disabled="readonly"
                  :method-params="{truckCmp:true,active:true}"
                  :default-value="truckingInfo.carryingCmp||''"
                  style="width:400px; display:inline-block"
                  @change="p=>{oldCarryingCmp = truckingInfo.carryingCmp || 0;truckingInfo.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
                />
              </el-form-item>

              <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageContactPerson')" class="custom">
                <el-select
                  v-model="truckingInfo.driver"
                  no="10"
                  style="width:400px"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  :allow-create="true"
                  :clearable="true"
                  filterable
                  @change="carryingContactsChangeHandler(false, false)"
                  @blur="selectContactBlur"
                >
                  <el-option
                    v-for="(item,index) in carryingContacts"
                    :key="index"
                    :label="item.contactPerson"
                    :value="item.contactPerson"
                  />
                </el-select>
              </el-form-item>

              <el-form-item class="custom" :label="loadingDateLabel">
                <el-date-picker
                  ref="loadingDate"
                  v-model="truckingInfo.loadingDate"
                  no="11"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width:400px"
                  @blur="()=> { handleBlur('loadingDate', null, true, true, truckingInfo) }"
                />
              </el-form-item>

              <el-form-item v-if="!isSalesForSzfs" :label="$t('Warehouse.Driver')" class="custom">
                <el-select
                  v-model="truckingInfo.driverName"
                  style="width:400px"
                  no="12"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  :allow-create="true"
                  :clearable="true"
                  filterable
                  @change="driverInfomationsChangeHandler"
                >
                  <el-option
                    v-for="(item,index) in driverInfomations"
                    :key="index"
                    :label="item.driverName"
                    :value="item.driverName"
                  />
                </el-select>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.travelTime')">
                <el-input-number
                  v-model="truckingInfo.travelHour"
                  no="13"
                  :min="0"
                  controls-position="right"
                  style="width:105px"
                />
                <span style="margin:10px">{{ $t('SeaExport.Hour') }}</span>
                <el-input-number
                  v-model="truckingInfo.travelMinute"
                  no="14"
                  :min="0"
                  :max="59"
                  controls-position="right"
                  style="width:100px"
                />
                <span style="margin:10px">{{ $t('SeaExport.Minute') }}</span>
              </el-form-item>

              <el-form-item :label="$t('SeaExport.DoorContactPerson')" class="custom">
                <el-input v-model="truckingInfo.doorMan" no="15" style="width:400px" />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.DoorAddress')" class="custom">
                <el-input v-model="truckingInfo.doorAddr" no="16" type="textarea" :rows="3" style="width:400px" />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.ZIP')" class="custom">
                <el-input v-model="truckingInfo.zipCode" no="zipCode" style="width:400px" />
              </el-form-item>

              <el-form-item class="auto-width" label-width="0">
                <div style="display: flex;">
                  <el-form-item class="custom" :label="$t('Pricing.BelongingCity')">
                    <cargo-advance-select
                      no="17"
                      style="width:160px"
                      :disabled="readonly"
                      :tag-name="$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                      tag-value="code"
                      :cache="false"
                      filterable
                      :default-value="truckingInfo.cityCode"
                      :static-options="cityList"
                      :placeholder="$t('SeaExport.PleaseSelect')"
                      @parentCallBack="p=>truckingInfo.cityCode=p.value"
                    />
                  </el-form-item>
                  <el-form label-width="100px" label-position="left">
                    <el-form-item class="custom" :label="$t('Warehouse.PalletSum')">
                      <el-input-number no="18" style="width:140px;" :value="truckingInfo.palletSum" :disabled="readonly" :min="0" :max="999999999999" :precision="0" :controls="false" @input="val=>{truckingInfo.palletSum=val || 0}" />
                    </el-form-item>
                  </el-form>
                </div>
              </el-form-item>

              <el-form-item label="PO">
                <el-input v-model="truckingInfo.po" no="po" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
              </el-form-item>
            </el-form>

            <el-form label-width="100px" label-position="left">
              <el-form-item class="custom" :label="$t('SeaExport.HaulageNo')">
                <el-input
                  v-model="truckingInfo.truckOrderNo"
                  no="19"
                  :disabled="readonly"
                  style="width:160px"
                  @change="refreshGrid"
                />
                <label>{{ $t('SeaExport.HaulageCharge') }}</label>
                <el-input-number
                  v-model="truckingInfo.truckingFee"
                  no="40"
                  :disabled="readonly"
                  :min="0"
                  :max="999999999999"
                  :precision="2"
                  controls-position="right"
                  style="width:120px"
                  @change="truckingFeeCharge"
                />
                <span class="currency">{{ localCurrency }}</span>
              </el-form-item>

              <el-form-item v-if="!isSalesForSzfs" class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.driverTel" no="41" :disabled="readonly" style="width:400px" @change="refreshGrid" />
              </el-form-item>

              <el-form-item class="custom" :label="actLoadingDateLabel">
                <el-date-picker
                  ref="actLoadingDate"
                  v-model="truckingInfo.actLoadingDate"
                  no="42"
                  :disabled="readonly"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width:400px"
                  @blur="()=> { handleBlur('actLoadingDate', null, true, true, truckingInfo) }"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.PlateNumber')" class="custom">
                <el-input
                  v-if="isEdit"
                  v-model="truckingInfo.plateNumber"
                  no="43"
                  :disabled="readonly"
                  style="width:280px;"
                  @input="(val)=>{truckingInfo.plateNumber = val.trim()}"
                />
                <span v-if="readonly" class="plate_number">{{ truckingInfo.plateNumber }}</span>
                <el-tooltip effect="light" :content="$t('SeaExport.ClickVehiclePositioningAndTrack')" placement="top">
                  <i class="el-icon-question vehicle-tip" />
                </el-tooltip>
              </el-form-item>

              <el-form-item v-if="!isSalesForSzfs" :label="$t('Warehouse.DriverPhone')" :disabled="txtEditEable" class="custom">
                <el-input
                  v-model="truckingInfo.driverPhone"
                  no="45"
                  :disabled="readonly"
                  style="width:400px;"
                />
              </el-form-item>

              <el-form-item :label="$t('SeaExport.Door')" class="custom">
                <cargo-repeat-value-select
                  v-model="truckingInfo.doorName"
                  :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                  filterable
                  :allow-create="true"
                  :disabled="readonly"
                  clearable
                  :options="doorList"
                  label-field="name"
                  value-field="name"
                  unique-field="uuid"
                  :match-of-repeat-value="matchOfRepeatDoor"
                  style="width: 400px"
                  @change="doorsChangeHandler"
                />
                <el-button v-show="$checkPermission(['button_Common_AddSite'])" no="addDoor" :disabled="!isEdit" class="vehicle-btn" type="primary" size="mini" @click="addDoor">{{ $t('Partners.doorInformation') }}</el-button>
              </el-form-item>

              <el-form-item class="custom" :label="$t('SeaExport.Tel')">
                <el-input v-model="truckingInfo.doorManTel" no="46" :disabled="readonly" style="width:400px" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                <el-input v-model="truckingInfo.remarks" no="47" :disabled="readonly" :filter-chars="false" type="textarea" :rows="3" style="width:400px" />
              </el-form-item>
              <el-form-item v-if="truckingInfo.dischargingPortService" :label="$t('CargoMsg.DischargingWay')">
                <el-select
                  :value="truckingInfo.dischargingWay?truckingInfo.dischargingWay.split(','):[]"
                  no="48"
                  :disabled="readonly"
                  multiple
                  style="width:400px"
                  @input="value=>{truckingInfo.dischargingWay=value.join(',')}"
                >
                  <el-option value="DROP" />
                  <el-option value="LIVE UNLOAD" />
                  <el-option value="EXCHANGE PALLETS" />
                  <el-option v-if="job.lob==='AI'" value="拼车" />
                  <el-option v-if="job.lob==='AI'" value="整车" />
                  <el-option v-if="job.lob==='AI'" value="快递" />
                  <el-option v-if="job.lob==='AI'" value="空运" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="truckingInfo.dischargingPortService" :label="$t('CargoMsg.LatestDeliveryDate')">
                <el-date-picker
                  ref="actDeliveryDate"
                  v-model="truckingInfo.actDeliveryDate"
                  no="actDeliveryDate"
                  :disabled="readonly"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width:400px"
                  @blur="()=> { handleBlur('actDeliveryDate', null, true, true, truckingInfo) }"
                />
              </el-form-item>
              <el-form-item class="custom" :label="$t('Partners.IdentityCard')">
                <el-input v-model="truckingInfo.driverIdCard" no="60" :disabled="readonly" style="width:400px" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div v-if="(job.lob==='SE' && !job.multipleCabinets) || job.lob==='SI' || job.lob==='RE' || job.lob==='RI'" class="app-main-inner-row operations">
        <div v-show="cooperateEdit" class="triggers">
          <div>
            <el-button no="48" type="primary" :disabled="!(btnEnable.grpTruckOrderBtns || (toExoSystemHc && job.trucking && job.trucking.length > 0))" @click="linkUsageClickHandler">{{ $t('SeaExport.AddPackingInfo') }}
            </el-button>
            <el-button no="49" type="danger" :disabled="!(btnEnable.grpTruckOrderBtns || (toExoSystemHc && job.trucking && job.trucking.length > 0))" @click="delLinkUsageClickHandler">{{ $t('SeaExport.RemovePackingInfo') }}
            </el-button>
            <!--为 编辑状态 el-dropdown 按钮 不可用 新增的按钮-->
            <el-button v-if="!btnEnable.grpTruckOrderBtns" no="50" type="primary" :disabled="!btnEnable.grpTruckOrderBtns">{{ command1 }}
            </el-button>
            <el-dropdown
              v-if="btnEnable.grpTruckOrderBtns"
              split-button
              type="primary"
              style="padding-left: 5px;"
              :disabled="!btnEnable.grpTruckOrderBtns"
              @click="btnConnectedTruckClickHandler()"
              @command="p=>{command1=p;btnConnectedTruckClickHandler()}"
            >
              {{ command1 }}
              <el-dropdown-menu slot="dropdown" :disabled="!btnEnable.grpTruckOrderBtns">
                <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.DispatchTuckOrder')">{{ $t('SeaExport.DispatchTuckOrder') }}
                </el-dropdown-item>
                <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.ModifyTuckOrder')">{{ $t('SeaExport.ModifyTuckOrder') }}
                </el-dropdown-item>
                <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.RevokeTuckOrder')">{{ $t('SeaExport.RevokeTuckOrder') }}
                </el-dropdown-item>
                <el-dropdown-item :disabled="!btnEnable.grpTruckOrderBtns" :command="$t('SeaExport.SearchTuckOrder')">{{ $t('SeaExport.SearchTuckOrder') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button no="51" :disabled="!btnEnable.grpTruckOrderBtns" type="primary" @click="showTuckOrderLogClickHandler">{{ $t('SeaExport.ShowTuckOrderLog') }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="(job.lob==='SE' && !job.multipleCabinets) || job.lob==='SI' || job.lob==='RE' || job.lob==='RI'" style="flex-grow:1;padding:10px">
        <cargo-ag-grid
          v-if="gridVisible.dgUsage"
          config-module="130136"
          no="52"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="usages"
          style="width:100%;height:350px"
          @gridReady="params=>gridApi=params.api"
        />
        <cargo-ag-grid
          v-if="gridVisible.dgUsageG7"
          config-module="130137"
          no="53"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefsG7"
          :row-data="usages"
          style="width:100%;height:350px"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div v-if="job.lob==='SE' && job.multipleCabinets" class="app-main-inner-row operations">
        <div v-show="cooperateEdit" class="triggers">
          <div>
            <el-button no="addCabinets" type="primary" :disabled="!btnEnable.grpTruckOrderBtns" @click="linkTruckRecordHandler">{{ $t('SeaExport.AddPackingInfo') }}
            </el-button>
            <el-button no="removeCabinets" type="danger" :disabled="!btnEnable.grpTruckOrderBtns" @click="dellinkTruckRecordHandler">{{ $t('SeaExport.RemovePackingInfo') }}
            </el-button>
            <el-button no="exportPackingInfo" type="primary" :disabled="!btnEnable.grpTruckOrderBtns" @click="exportTruckExcelData">{{ $t('SeaExport.ExportPackingInfo') }}
            </el-button>
            <el-upload
              action="string"
              :http-request="importTruckDataExcel"
              :show-file-list="false"
              :disabled="!btnEnable.grpTruckOrderBtns"
              accept=".xls, .xlsx"
              :before-upload="beforeUploadUsage"
              style="display: inline-block;padding-left: 5px;"
            >
              <el-button no="importPackingInfo" type="primary" :disabled="!btnEnable.grpTruckOrderBtns">
                {{ $t('SeaExport.ImportPackingInfo') }}
              </el-button>
            </el-upload>
            <el-button no="exportErrorExcel" type="primary" :disabled="!btnEnable.grpTruckOrderBtns || !importExcelResultID" @click="exportErrorExcel">{{ $t('SeaExport.DownloadImportResults') }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="job.lob==='SE' && job.multipleCabinets" style="flex-grow:1;padding:10px">
        <cargo-ag-grid
          no="gridCabinets"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="cabinetColumnDefs"
          :row-data="truckingRecords"
          style="width:100%;height:350px"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 选择装箱信息弹窗 -->
    <trucking-container-usage-link-dialog
      :visible.sync="containerUsageDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      :modify-usage-in-edit-mode="modifyUsageInEditMode"
      :data="containerUsageDialog.data"
      @selectContainerUsageHandler="selectContainerUsageHandler"
      @saveContainerUsageData="saveContainerUsageHandler"
    />
    <!-- 多柜-选择装箱信息弹窗 -->
    <trucking-container-record-link-dialog
      :visible.sync="containerTruckingRecordDialog.visible"
      :job-uuid="job.uuid"
      :trucking-info-uuid="truckingInfo.uuid"
      @selectTruckingRecordHandler="selectTruckingRecordHandler"
    />
    <!-- 信息维护 -->
    <information-maintenance-dialog
      :visible.sync="informationDialog.visible"
      :site="informationDialog.site"
      :title="informationDialog.title"
      @syncSiteToJob="syncSiteToJob"
      @refresh="loadSites"
    />
    <!-- 日志弹出窗 -->
    <tuck-order-log-dialog
      :visible.sync="truckOrderLogDialog.visible"
      :row-data="truckOrderLogDialog.rowData"
    />
    <!-- 日志弹出窗 -->
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :row-data="errorLogDialog.rowData"
    />

    <!-- 附件 -->
    <upload-common-file
      :visible.sync="uploadCommonFileDialog.visible"
      :model="uploadCommonFileDialog.model"
    />

    <!-- 门点信息公共弹窗 -->
    <door-point-information
      :v-if="addDoorDialog.visible"
      :visible.sync="addDoorDialog.visible"
      :show-area="toExoSystemHc"
      :action="action"
      :site="addDoorDialog.form"
      @loadSites="loadSites"
    />
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { DateAutoInitRuleManage } from '@/class/cargo/model/utils/DateAutoInitRuleManage'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import { Trucking } from '@/class/model/booking/Trucking'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { delContaierUsageLinkedTruckingInfo, queryByTruckingInfo, containerUsagesByJobUuid } from '@/api/seaExport/containerUsage'
import { queryTruckingByTruck, delTruckingRecord, importTruckExcelData } from '@/api/seaExport/containerTruckingRecord'
import { Company } from '@/class/model/mdm/Company'
import { addSites, getSitesFunc } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import SoNoSelector from '@/components/Cargo/Job/soNoSelector'
import { TabError } from '@/utils/class/TabError'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import TruckingContainerUsageLinkDialog from '@/components/Cargo/Job/truckingContainerUsageLinkDialog'
import TruckingContainerRecordLinkDialog from '@/components/Cargo/Job/truckingContainerRecordLinkDialog'
import TuckOrderLogDialog from '@/components/Cargo/Job/tuckOrderLogDialog'
import ErrorLogDialog from '@/components/Cargo/Job/errorLogDialog'
import UploadCommonFile from '@/components/Cargo/Job/uploadCommonFile'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import {
  sendTruckOrder,
  sendTruckOrder2Duck,
  sendModifiedTruckOrder,
  revokeTruckOrder,
  getTruckOrder,
  queryTuckOrderLog,
  queryEventLogList,
  syncTruckingToDischargingTruckingInfo,
  matchingPriceFunc, matchingPricePageFunc
} from '@/api/seaExport/trucking'
import { DocumentManage } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ensureExecuteSuccess, handleBlur } from '@/utils/commonUtil'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'
import { updateTrackingForDocumentType } from '@/api/fileHistory'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getLocationList } from '@/api/location'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import URL from '@/api/urlTranslator'
import { getSettlementAgentsByCmpIdx, getSettlementAgentsByCmpIdxList } from '@/api/company'
import StateDialog from '@/components/Cargo/Job/StateDialog.vue'
import { deepClone } from '@/utils'
import AddDoorDialog from '@/views/cargo/v0/SeaExport/components/booking/addDoorDialog.vue'
import DateUtils from '@/utils/dateUtils'
import DoorPointInformation from '@/views/cargo/v0/Information/components/partner/tab/doorPointInformation.vue'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index.vue'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index.vue'
import InformationMaintenanceDialog from '@/components/Cargo/Job/InformationMaintenanceDialog.vue'
import uidUtil from '@/utils/uidUtil'

export default {
  name: 'TabTrucking',
  components: {
    InformationMaintenanceDialog,
    DoorPointInformation,
    AddDoorDialog,
    StateDialog,
    CargoDateTimeFieldInput, UploadCommonFile, ErrorLogDialog, TruckingContainerUsageLinkDialog, TruckingContainerRecordLinkDialog, TuckOrderLogDialog, SoNoSelector, cargoAdvanceSelect, cargoCompanySelect,
    cargoRepeatValueSelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    from: {
      type: String,
      default: () => null
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      unBindContainerUsageUuids: [], // 解绑门点-装箱信息关系
      handleBlur,
      currentViewCacheData: {
        customerSettlementAgentMap: new Map() // 结算对象关联的结算代理
      },
      locationList: [],
      addDoorDialog: {
        visible: false,
        form: {
          title: '',
          name: '',
          contact: '',
          phone: '',
          address: '',
          remarks: '',
          city: '',
          companyUuid: '',
          companyName: ''
        }
      },
      V3mail: {},
      loading: null,
      selectTypeNames: TYPE_NAMES,
      topgridApi: null,
      top: {
        visible: true,
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          suppressCopyRowsToClipboard: true,
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocused(event)
          },
          onRowClicked: this.selectionChangeHandler
        }
      },
      command1: this.$t('SeaExport.DispatchTuckOrder'),
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridDateTimeEditor
        }
      },
      columnDefsG7: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'uuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          field: 'tosCarNum',
          width: 110
        },
        {
          headerName: this.$t('SeaExport.PlannedDepartureTime'),
          field: 'tosStartTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualDepartureTime'),
          field: 'tosGstartTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedArrivalTimeAtTheFactory'),
          field: 'tosInTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.RealTimeOfArrivalAtTheFactory'),
          field: 'tosGinTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedTimeToLeaveTheFactory'),
          field: 'tosOutTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualTimeToLeaveTheFactory'),
          field: 'tosGoutTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PlannedArrivalTime'),
          field: 'tosEndTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualArrivalTime'),
          field: 'tosGarriveTime',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.currentLocation'),
          field: 'tosLocation',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ViewExceptions'),
          field: 'tosTaskId',
          width: 100,
          cellRenderer: params => {
            const showErrorLogClickHandler = this.documentManage.getPath('showErrorLogClickHandler')
            return `<a onclick="${showErrorLogClickHandler}('${params.value}')" style="color:blue">${this.$t('SeaExport.ViewExceptions')}</a>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridParams: {},
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      currentHcDoorTrucking: null,
      multiPickups: false,
      trucking: [],
      cityList: [],
      truckingInfo: new Trucking().fillDefaultValue().getData(), // 初始化
      oldTruckintFee: 0,
      soNo: '',
      btnEnable: {
        btDel: false,
        grpTruckOrderBtns: false
      },
      gridVisible: {
        dgUsage: false,
        dgUsageG7: false
      },
      usages: [],
      isAllowGridClick: false, // 是否允许触发门点grid的点击事件
      needReloadDriver: false, // 切换公司时, 重新读取司机信息, 否则不读取
      neednotReloadTelephone: false, // 表格内切换门点时, 不按照联系人名称重新读取电话
      txtEditEable: false, // 编辑文本框是否允许编辑
      needSaveCustomer: false, // 是否需要更新job.customer
      txtTMSHint: '',
      carryingContacts: [],
      driverInfomations: [],
      doorList: [],
      matchOfRepeatDoor: options => {
        const option = options.find(p => p.contact === this.truckingInfo.doorMan)
        return option || options[0]
      },
      delTruckingInfoUuids: [], // 记录删除的uuid
      containerUsageDialog: {
        visible: false,
        data: []
      },
      informationDialog: {
        visible: false,
        site: {
          title: '',
          name: '',
          contact: '',
          phone: '',
          country: 'CN',
          province: '',
          cityNew: '',
          county: '',
          town: '',
          address: '',
          companyUuid: '',
          companyName: ''
        }
      },
      truckOrderLogDialog: {
        visible: false,
        rowData: []
      },
      errorLogDialog: {
        visible: false,
        rowData: []
      },
      uploadCommonFileDialog: {
        visible: false,
        model: {}
      },
      hcInfoTrucking: [],
      hcDoorTrucking: [],
      soNoAllSet: new Set(),
      driverAllSet: new Set(),
      hcTruckingInfo: new Trucking().fillDefaultValue().getData(), // 初始化
      toExoSystemHc: false,
      hcTrucking: [],
      hcInfo: {
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          suppressCopyRowsToClipboard: true,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridAdvanceMultipleSelectEditor,
            CargoAgGridCommonTextareaEditor
          },
          onRowClicked: this.selectionHcChangeHandler
        }
      },
      hcDoor: {
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          suppressCopyRowsToClipboard: true,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonTextareaEditor,
            CargoAgGridDateTimeEditor
          },
          onRowClicked: this.selectionHcDoorChangeHandler
        }
      },
      documentManage: new DocumentManage(),
      containerUsages: [], // 记录装箱明细 修改的拖车费
      containers: [], // 记录装箱信息
      truckingRecords: [],
      containerTruckingRecordDialog: {
        visible: false
      },
      importExcelResultID: '', // 导入多柜装箱信息结果文件ID
      multiTruckingShow: (parseInt(cache.config.get('MultiTruckingShow')) === 1), // 是否开启多柜模式
      oldCarryingCmp: 0 // 上一次的运输公司
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    modifyUsageInEditMode() {
      return this.toExoSystemHc && this.isEdit
    },
    showSecondSync() {
      if (this.job.lob === 'AI') {
        if (this.isEdit) {
          return false
        }
        if (this.job.multiplePickups) {
          for (const item of this.trucking) {
            if (item.relatedDischargingTrucking) {
              return true
            }
          }
          return false
        } else {
          return Boolean(this.truckingInfo.relatedDischargingTrucking)
        }
      }
      return false
    },
    topConfigModuel() {
      if (this.job.lob === 'SE') {
        return '130142'
      }
      return ''
    },
    columnDefs() {
      const baseList = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqSize')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerNo')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'containerWeight')
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'sealNo')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          headerClass: this.toExoSystemHc ? 'trucking-title-red' : '',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.estimatedDeliveryTime'), field: 'estimatedDeliveryTime', colId: 'estimatedDeliveryTime', width: 150,
          valueFormatter: (params) => {
            return this.estimatedDisplayFunction(params, 'estimatedDeliveryTime')
          },
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: this.isEdit
            }
          },
          onCellValueChanged: p => this.onTimeCellChange(p)
        },
        { headerName: this.$t('SeaExport.estimatedArrivalTime'), field: 'estimatedArrivalTime', colId: 'estimatedArrivalTime', width: 150,
          valueFormatter: (params) => {
            return this.estimatedDisplayFunction(params, 'estimatedArrivalTime')
          },
          hide: true,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: this.isEdit
            }
          },
          onCellValueChanged: p => this.onTimeCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.TuckStatus'),
          field: 'truckStatus',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.truckingOrderLableFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TuckStatusDescription'),
          field: 'description',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDep'),
          field: 'truckingPlaceOfDep',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UploadAttachment'),
          field: 'uuid',
          width: 120,
          cellRenderer: params => {
            const uploadFileClickHandler = this.documentManage.getPath('uploadFileClickHandler')
            return `<a onclick="${uploadFileClickHandler}('${params.value}')" style="color:blue">${this.$t('CargoMsg.Cargo_Attachment')}</a>`
          }
        },
        {
          headerName: this.$t('SeaExport.HLID'),
          field: 'dcSequence',
          width: 120,
          cellRenderer: (params) => {
            if (!StrUtils.isEmpty(params.data.dcTicketNo) && !StrUtils.isEmpty(params.data.dcSequence)) {
              return params.data.dcTicketNo + '_' + params.data.dcSequence
            } else {
              return params.data.dcSequence
            }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNoDiff'),
          field: 'containerNoDiff',
          width: 120,
          headerClass: 'red',
          cellStyle: { color: 'red!important' }
        },
        {
          headerName: this.$t('SeaExport.DriverNameHL'),
          field: 'driverNameHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhoneHL'),
          field: 'driverPhoneHL',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNoHL'),
          field: 'truckNoHL',
          width: 120
        },
        /* cargo 中未显示对应的列  {
          headerName: this.$t('SeaExport.dcTicketNo'),
          field: 'dcTicketNo',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.dcSequence'),
          field: 'dcSequence',
          width: 120,
          hide: true
        },*/
        {
          headerName: this.$t('SeaExport.ContainerSerialNo'),
          field: 'serialNo',
          width: 120
        }
      ]
      if (!this.toExoSystemHc) {
        baseList.push({
          headerName: this.$t('SeaExport.HaulageCharge'),
          field: 'truckingFee',
          width: 120,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-input-number',
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.AuditMoney'),
          field: 'auditMoney',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.AuditState'),
          field: 'auditState',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.costStatusLableFun(params.data, 'auditState')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConfirmExpenses'),
          field: 'auditUrl',
          width: 120,
          cellRenderer: params => {
            if (params.data.auditUrl && !params.data.auditState) {
              const auditUrlClickHandler = this.documentManage.getPath('auditUrlClickHandler')
              return `<a onclick="${auditUrlClickHandler}('${params.value}')" style="color:blue">${this.$t('CargoMsg.Cargo_ConfirmExpenses')}</a>`
            } else return ''
          }
        })
      }
      return baseList
    },
    cabinetColumnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.DriverName'),
          field: 'driverName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhone'),
          field: 'driverPhone',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverId'),
          field: 'driverId',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNo'),
          field: 'truckNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDep'),
          field: 'truckingPlaceOfDep',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.EstimatArrivalTime'),
          field: 'estimatedArrivalTime',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TrailerRemark'),
          field: 'trailerRemark',
          width: 120
        }
      ]
    },
    sessionId() {
      return this.$store.getters.token
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    },
    loadingDateLabel() {
      let label = this.$t('SeaExport.CargosExpectedArrivalDatePacking')
      if (this.job && this.job.lob !== 'SE') {
        label = this.truckingInfo && this.truckingInfo.loadingPortService ? this.$t('SeaExport.CargosExpectedArrivalDatePacking') : this.$t('CargoMsg.EstimatedDeliveryDate')
      }
      return label
    },
    actLoadingDateLabel() {
      let label = this.$t('SeaExport.CargoActArrivalDatePacking')
      if (this.job && this.job.lob !== 'SE') {
        label = this.truckingInfo && this.truckingInfo.loadingPortService ? this.$t('SeaExport.CargoActArrivalDatePacking') : this.$t('CargoMsg.ActualDeliveryDate')
      }
      return label
    },
    hcInfoColumnDef() {
      return [
        {
          headerName: this.$t('SeaExport.HaulageNo'),
          colId: 'showTruckOrderNo',
          field: 'showTruckOrderNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.HaulageCompany'), colId: 'carryingCmp', field: 'carryingCmp', initialWidth: 250,
          headerClass: 'trucking-title-red',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_Company,
              methodParams: { truckCmp: true, active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryArea'), colId: 'deliveryArea', field: 'deliveryArea', initialWidth: 250
        },
        {
          headerName: this.$t('SeaExport.TeamContact'),
          colId: 'driver',
          field: 'driver',
          width: 100,
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FleetPhoneNumber'),
          colId: 'driverTel',
          field: 'driverTel',
          width: 100,
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.RemarkItems'),
          colId: 'remarkItems',
          field: 'remarkItems',
          width: 180,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.PlateNumber'),
          colId: 'plateNumber',
          field: 'plateNumber',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = (this.driverAllSet[params.data.carryingCmp] || [])
            return {
              selectProps: {
                tagValue: 'plateNumber',
                tagName: 'plateNumber',
                staticOptions,
                filterable: true,
                filterTagNames: ['plateNumber']
              }
            }
          },
          onCellValueChanged: p => this.onPlateNumberChange(p)
        },
        {
          headerName: this.$t('Warehouse.DriverPhone'),
          colId: 'driverPhone',
          field: 'driverPhone',
          width: 120,
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('SeaExport.HaulageCharge') + '(RMB)',
          headerClass: 'trucking-title-red',
          colId: 'truckingFee',
          field: 'truckingFee',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: 'S/O No.',
          colId: 'soNo',
          field: 'soNo',
          width: 150,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: (params) => {
            return {
              selectProps: {
                multiple: true,
                tagValue: 'soNo',
                tagName: 'soNo',
                staticOptions: [...this.soNoAllSet],
                filterable: true
              }
            }
          },
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('Partners.IdentityCard'),
          colId: 'driverIdCard',
          field: 'driverIdCard',
          width: 140,
          editable: false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onHcInfoCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Instructions'),
          colId: 'containerDesc',
          field: 'containerDesc',
          width: 200
        }
      ]
    },
    hcDoorColumDef() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_DeliverySequenceNumber'),
          colId: 'deliveryNo',
          field: 'deliveryNo',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          },
          onCellValueChanged: p => this.onDeliveryNoCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DoorPointName'),
          headerClass: 'trucking-title-red',
          colId: 'doorName', field: 'doorName', initialWidth: 150,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.doorList
            return {
              selectProps: {
                tagValue: 'name',
                tagName: 'name',
                staticOptions,
                filterable: true,
                filterTagNames: ['name']
              }
            }
          },
          onCellValueChanged: p => this.onHcDoorCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Province'),
          field: 'province',
          colId: 'province',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_city'),
          field: 'cityNewStr',
          colId: 'cityNewStr',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CountyDistrict'),
          field: 'countyStr',
          colId: 'countyStr',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TownStreet'),
          field: 'townStr',
          colId: 'townStr',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), flex: 1,
          cellRenderer: params => {
            const informationSupplementHandle = this.documentManage.getPath('informationSupplementHandle')
            const uuid = params.data.uuid
            const tempUuid = params.data.tempUuid
            const name = this.$t('CargoMsg.CargoMsg_Information_Supplement')
            if (this.isEdit) {
              return `<button><div onclick="${informationSupplementHandle}('${uuid}', '${tempUuid}')" style="display: inline-block;margin-right: 5px;cursor: pointer">${name}</div></button>`
            } else {
              return `<button disabled ><div onclick="${informationSupplementHandle}('${uuid}', '${tempUuid}')" style="display: inline-block;margin-right: 5px;">${name}</div></button>`
            }
          }
        },
        {
          headerName: this.$t('RailwayExport.DetailedAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Contact'),
          colId: 'doorMan',
          field: 'doorMan',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          colId: 'doorManTel',
          field: 'doorManTel',
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AdditionalRemark'),
          field: 'remarks',
          colId: 'remarks',
          width: 150,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          colId: 'quantity',
          field: 'quantity',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedLoadingTime'),
          headerClass: 'trucking-title-red',
          field: 'loadingDate',
          colId: 'loadingDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: false
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualLoadingTime1'),
          field: 'actLoadingDate',
          colId: 'actLoadingDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          editable: this.isEdit,
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editable: false
            }
          }
        }
      ]
    },
    topColumnDefs() {
      return [
        /* {
          headerName: this.$t('SeaExport.SequenceNumber'), width: 130, checkboxSelection: true, pinned: 'left', colId: 'serialNumber', field: 'carryingCmp',
          sortable: true, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true, lockVisible: true
        },*/
        {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          initialHide: this.isSalesForSzfs,
          suppressColumnsToolPanel: this.isSalesForSzfs,
          lockVisible: true
        },
        {
          headerName: this.$t('SeaExport.HaulageNo'),
          field: 'truckOrderNo',
          colId: 'truckOrderNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Door'),
          field: 'doorName',
          colId: 'doorName',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.ContactPerson'),
          field: 'driver',
          colId: 'driver',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Tel'),
          field: 'driverTel',
          colId: 'driverTel',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          colId: 'containerNo',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          width: 200,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          colId: 'remarks',
          width: 200,
          hide: true
        }
      ]
    }
  },
  watch: {
    topConfigModuel() {
      this.top.visible = false
      this.$nextTick(() => {
        this.top.visible = true
      })
    }
  },
  async created() {
    this.cityList = await getLocationList({}).then((res) => {
      return res.data.list || []
    })
  },
  beforeMount() {
    const context = this
    this.documentManage.set('informationSupplementHandle', function(uuid, tempUuid) {
      context.informationSupplementHandle(uuid, tempUuid)
    })
    this.documentManage.set('uploadFileClickHandler', function(value) {
      context.uploadFileClickHandler(value)
    })
    this.documentManage.set('auditUrlClickHandler', function(value) {
      context.auditUrlClickHandler(value)
    })
    this.documentManage.set('showErrorLogClickHandler', function(value) {
      context.showErrorLogClickHandler(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    resetColumnState() {
      for (const item of this.columnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = !this.readonly
        }
      }
    },
    async onShow(row, isRefresh) {
      this.job = row
      this.loadSites()
      await this.getAllSoNoHandler()
      await this.loadDriverInfomations()
      if (!isRefresh) {
        if (this.modifyUsageInEditMode && this.trucking && this.trucking.length > 0) {
          this.trucking.forEach(item => {
            if (this.job.containerUsages && this.job.containerUsages.length > 0) {
              item.usages = this.job.containerUsages.filter(p => p.truckingInfoUuid === item.uuid)
            } else {
              item.usages = []
            }
          })
          if (this.truckingInfo) {
            this.usages = this.truckingInfo.usages || []
          }
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true })
          }
        }
        return
      }
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.toExoSystemHc = String(cache.config.get('ToExoSystem')) === 'HC'
      // 加载数据
      await this.startLoad(row)
      // 组装 门点下的装箱信息
      if (this.modifyUsageInEditMode && this.trucking && this.trucking.length > 0) {
        this.trucking.forEach(item => {
          if (this.job.containerUsages && this.job.containerUsages.length > 0) {
            item.usages = this.job.containerUsages.filter(p => p.truckingInfoUuid === item.uuid)
          } else {
            item.usages = []
          }
        })
      }
      await this.autoCalculateDateRule()
      this.multiPickupsEnabled()
      // 加载数据又一次 编辑时才会调用
      this.checkDefaultTrucking()
      this.btnEnable.grpTruckOrderBtns = this.readonly && (this.job.trucking && this.job.trucking.length > 0)
      // 加载海创定制化数据
      if (this.toExoSystemHc) {
        this.job.multiplePickups = true
        this.refreshInfo('', false)
        this.loadDriverData()
      }
    },
    sortTrucking(trucking) {
      return trucking.sort((a, b) => {
        const suffixA = a.truckOrderNo.replace(`${this.job.jobNo}_`, '')
        const suffixB = b.truckOrderNo.replace(`${this.job.jobNo}_`, '')
        const diff = suffixB - suffixA
        if (diff === 0) {
          if (a.dateModified > b.dateModified) {
            return -1
          } else if (a.dateModified < b.dateModified) {
            return 1
          } else {
            return 0
          }
        }
        return diff
      })
    },
    setDefaultPortService(truckingInfo) {
      const lob = this.job.lob
      if (lob === 'AE' || lob === 'SE' || lob === 'RE') {
        truckingInfo.loadingPortService = true
      } else {
        truckingInfo.dischargingPortService = true
      }
    },
    onLoadingPortServiceChange() {
      this.truckingInfo.dischargingPortService = !this.truckingInfo.loadingPortService
    },
    onDischargingPortServiceChange() {
      this.truckingInfo.loadingPortService = !this.truckingInfo.dischargingPortService
    },
    async startLoad(row) {
      if (!this.job) return
      this.showDgUsageByG7()
      // 加载数据
      const job = new SeaExportJob(row)
      if (this.readonly || !job.trucking || job.trucking.length <= 0) {
        job.trucking = ''
      }
      if (this.readonly) {
        job.charges = ''
      }
      await Promise.all([
        job.getContainerUsages(),
        job.getTrucking(),
        job.getCharges()
      ])
      await this.syncMissingTruckingCharges()
      this.trucking = this.sortTrucking(job.trucking)
      if (this.trucking && this.trucking.length > 0) {
        this.setContainerNo(this.trucking, this.job.containerUsages)
        this.truckingInfo = this.job.trucking[0]
        this.setOldCarryingCmp()
        if (StrUtils.isEmpty(this.truckingInfo.truckOrderNo)) {
          this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
          this.truckingInfo.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
        }
        this.$nextTick(async() => {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.topgridApi)
          this.setGridSelect()
          this.selectionChangeHandler({ data: this.truckingInfo })
        })
      } else { // 非编辑没有门点信息，则默认为空
        if (!this.isEdit) {
          this.truckingInfo = new Trucking().fillDefaultValue().getData()
          this.setDefaultPortService(this.truckingInfo)
          this.setOldCarryingCmp()
        }
      }
    },
    async syncMissingTruckingCharges() {
      if (!this.isEdit || !Array.isArray(this.job.trucking) || this.job.trucking.length === 0) {
        return
      }
      if (!Array.isArray(this.job.charges)) {
        this.job.charges = []
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode'))
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (!chargeItem || !chargeItem.active) {
        return
      }
      const showTruckOrderNoSet = new Set()
      const currentTruckingInfo = this.truckingInfo
      try {
        for (const trucking of this.job.trucking) {
          if (!trucking || !(Number(trucking.truckingFee) > 0) || !trucking.truckOrderNo) {
            continue
          }
          if (this.toExoSystemHc) {
            const showTruckOrderNo = trucking.showTruckOrderNo || trucking.truckOrderNo
            if (showTruckOrderNoSet.has(showTruckOrderNo)) {
              continue
            }
            showTruckOrderNoSet.add(showTruckOrderNo)
          }
          const hasCharge = this.job.charges.some(charge => !charge.receivable && charge.truckOrderNo === trucking.truckOrderNo)
          if (hasCharge) {
            continue
          }
          this.truckingInfo = trucking
          await this.createCharge(true)
        }
      } finally {
        this.truckingInfo = currentTruckingInfo
      }
    },
    setContainerNo(trucking, containerUsages) {
      const containerNoMap = new Map()
      for (const item of containerUsages) {
        if (!item.truckingInfoUuid) {
          continue
        }
        let containerNo = containerNoMap.get(item.truckingInfoUuid)
        if (containerNo) {
          containerNo += ',' + item.containerNo
        } else {
          containerNo = item.containerNo
        }
        containerNoMap.set(item.truckingInfoUuid, containerNo)
      }
      for (const item of trucking) {
        item.containerNo = containerNoMap.get(item.uuid) || ''
      }
    },
    syncToDischargingTruckingInfo() {
      const truckingInfoKeys = []
      if (this.job.multiplePickups) {
        for (const item of this.trucking) {
          if (item.relatedDischargingTrucking) {
            truckingInfoKeys.push(item.uuid)
          }
        }
      } else {
        if (this.truckingInfo.relatedDischargingTrucking) {
          truckingInfoKeys.push(this.truckingInfo.uuid)
        }
      }
      const loading = getLoading4Cxt(this)
      syncTruckingToDischargingTruckingInfo(truckingInfoKeys).then(res => {
        this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      }).finally(() => {
        loading.close()
      })
    },
    onCellFocused(event) {
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        if (this.topgridApi && event.column) {
          this.topgridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              node.setSelected(true)
              this.truckingInfo = node.data
              this.setOldCarryingCmp()
            }
          })
        }
      })
    },
    // 设置 选中行(加载数据后默认选中第一行记录)
    setGridSelect(selectLastRow = false) {
      // 如果不是多门点，就不需要执行一下方法，不会显示选择门店的列表，所以不需要执行以下程序代码
      if (!this.job.multiplePickups) { return }
      const nodes = this.topgridApi ? this.topgridApi.getRenderedNodes() : []

      // 如无行记录数据，选中值重新设置
      if (!this.truckingInfo || nodes.length === 0) {
        this.truckingInfo = new Trucking().fillDefaultValue().getData()
        this.setDefaultPortService(this.truckingInfo)
        this.setOldCarryingCmp()
      }

      // 选中最后一行记录(用于 行复制 新增，删除)
      if (selectLastRow) {
        let index = 0
        for (const item of nodes) {
          if (index === nodes.length - 1) {
            item.setSelected(true)
            this.truckingInfo = item.data
            this.setOldCarryingCmp()
            this.topgridApi.setFocusedCell(index, 'carryingCmp')
            break
          }
          index++
        }
      } else {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.truckingInfo = item.data
          this.setOldCarryingCmp()
          this.topgridApi.setFocusedCell(0, 'carryingCmp')
          break
        }
      }
    },
    // 门店地址
    async loadSites() {
      // 同步实现 loadSiteResultHandler
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      await getSitesFunc({ companyUuid: companyUuid, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.doorList = res.data
      })
    },
    async loadDriverInfomations() {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.carryingCmp)
      if (companyCache && companyCache.uuid) {
        this.driverInfomations = await Company.loadDriverInformation(companyCache.uuid)
      } else {
        this.driverInfomations = []
      }
    },
    async loadDriverData() {
      if (!this.hcInfoTrucking || this.hcInfoTrucking.length === 0) {
        return
      }
      for (const data of this.hcInfoTrucking) {
        const list = this.driverAllSet[data.carryingCmp]
        if (list) {
          continue
        }
        const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', data.carryingCmp)
        let driverInfos = []
        if (companyCache && companyCache.uuid) {
          driverInfos = await Company.loadDriverInformation(companyCache.uuid)
          this.driverAllSet[data.carryingCmp] = driverInfos
        }
      }
    },
    showDgUsageByG7() {
      if (parseInt(cache.config.get('showDgUsageByG7')) === 1) {
        this.gridVisible.dgUsage = false
        this.gridVisible.dgUsageG7 = true
      } else {
        this.gridVisible.dgUsage = true
        this.gridVisible.dgUsageG7 = false
      }
    },
    checkDefaultTrucking() {
      if (!this.job) return
      if (this.isEdit) {
        if (!this.trucking || this.trucking.length === 0) {
          this.truckingInfo = new Trucking().fillDefaultValue().getData()
          this.setDefaultPortService(this.truckingInfo)
          this.truckingInfo.quantity = this.job.quantityActual
          this.truckingInfo.weight = this.job.weightActual
          this.truckingInfo.cubage = this.job.cubageActual
          this.truckingInfo.jobUuid = this.job.uuid
          this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
          this.truckingInfo.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
          this.truckingInfo.deliveryNo = 1
          this.setOldCarryingCmp()
          this.trucking.push(this.truckingInfo)
        } else {
          this.truckingInfo = this.job.trucking[0]
          this.setOldCarryingCmp()
          if (StrUtils.isEmpty(this.truckingInfo.truckOrderNo)) {
            this.truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
            this.truckingInfo.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
          }
        }
        this.selectionChangeHandler({ data: this.truckingInfo })
      }
      this.loadTruckingInfoUsage(this.truckingInfo)
      this.loadTruckingRecord(this.truckingInfo)
    },
    async autoCalculateDateRule() {
      await DateAutoInitRuleManage.getInstance().autoCalculateDateRule(this.job, this.truckingInfo, 'SE')
    },
    multiPickupsEnabled() {
      if (this.isEdit && this.job && !StrUtils.isEmpty(this.job.uuid)) {
        this.multiPickups = true
      } else {
        this.multiPickups = false
      }
    },
    selectionChangeHandler(event) {
      if (!event.data) {
        return
      }
      this.V3mail = {
        truckingId: event.data.uuid
      }
      this.truckingInfo = event.data
      this.setOldCarryingCmp()
      this.neednotReloadTelephone = true
      this.txtEditEable = this.isEdit && (this.truckingInfo.sendState === 0)
      this.checkBtnsState()
      this.fillView()
      this.filterSONo()
      // CARGO-16946 H5 海运订舱极速版 客户门点-多门点，添加装箱信息，会同时显示在其他门点里
      this.loadTruckingInfoUsage(this.truckingInfo)
      this.resetColumnState()
      this.refreshGrid()
    },
    fillView() {
      if (!this.truckingInfo) return
      // 控制派车单按钮
      if (!this.truckingInfo.uuid) {
        this.btnEnable.grpTruckOrderBtns = false
      } else {
        this.btnEnable.grpTruckOrderBtns = this.readonly && (this.job.trucking && this.job.trucking.length > 0)
      }
      this.carringCapChange()
      this.refreshGrid()
    },
    // change carrying company
    async carringCapChange() {
      // 同步实现 carryingContactResultHandler
      if (!this.truckingInfo || this.truckingInfo.carryingCmp <= 0) return
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.truckingInfo.carryingCmp))
      if (!companyCache) {
        this.truckingInfo.carryingCmp = 0
        this.isNullData()
        return
      }
      const company = new Company({ cmpIdx: this.truckingInfo.carryingCmp })
      if (!company) return
      this.carryingContacts = await company.getContactsBycmpIdx()

      if (this.carryingContacts && this.carryingContacts.length > 0) {
        if (!this.truckingInfo.driver) {
          this.truckingInfo.driver = this.carryingContacts[0].contactPerson
        }
      } else {
        this.isNullData()
      }
      if (!this.truckingInfo.driver) return
      this.carryingContactsChangeHandler(this.needReloadDriver, this.neednotReloadTelephone)
    },
    isNullData() {
      this.carryingContacts = []
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
    },
    carryingContactsChangeHandler(needReloadDriver = false, needNotReloadTelephone = false) {
      if (!this.truckingInfo || !this.truckingInfo.driver) return
      this.neednotReloadTelephone = needNotReloadTelephone
      this.needReloadDriver = needReloadDriver
      // console.log('======================', value, this.carryingContacts, contact)
      if (this.carryingContacts && this.carryingContacts.length > 0) {
        for (const item of this.carryingContacts) {
          if (item && item.contactPerson && item.contactPerson === this.truckingInfo.driver) {
            if (!this.neednotReloadTelephone) {
              this.truckingInfo.driverTel = item.telephone
              break
            }
          }
        }
      } else {
        const contacts = this.carryingContacts
        if (contacts && contacts.length > 0 && this.needReloadDriver) {
          const cat = contacts[0]
          this.truckingInfo.driver = cat.contactPerson
          this.truckingInfo.driverTel = cat.telephone
        } else {
          this.truckingInfo.driver = ''
          if (this.needReloadDriver) {
            this.truckingInfo.driverTel = ''
          }
        }
      }
      this.refreshGrid()
    },
    driverInfomationsChangeHandler() {
      if (!this.truckingInfo || !this.truckingInfo.driverName) return
      if (this.driverInfomations && this.driverInfomations.length > 0) {
        for (const item of this.driverInfomations) {
          if (item && item.driverName && item.driverName === this.truckingInfo.driverName) {
            this.truckingInfo.driverPhone = item.driverPhone
            this.truckingInfo.plateNumber = item.plateNumber
            this.truckingInfo.driverIdCard = item.driverIdCard
          }
        }
      }
    },
    setSelectDoor() {
      // 选中 门点，vue 双向绑定 不需要实现
    },
    checkBtnsState() {
      this.btnEnable.btDel = this.isEdit && this.truckingInfo != null
    },
    // 过滤S/O No
    filterSONo() {
      this.soNo = ''
      if (this.job.lob === 'SE') {
        if (this.isEdit) {
          const soNos = this.job.soNo == null ? [] : this.job.soNo.split('\n')
          const len = soNos.length
          for (let i = len - 1; i >= 0; i--) {
            const s = soNos[i]
            for (const truck of this.job.trucking) {
              if (truck === this.truckingInfo) {
                continue
              }
              let isIn = false
              if (truck.soNo && truck.soNo.length > 0) {
                const ts = truck.soNo.split('\n')
                for (const t of ts) {
                  if (t === s) {
                    isIn = true
                    soNos.splice(i, 1)
                    break
                  }
                }
              }
              if (isIn) {
                break
              }
            }
          }
          this.soNo = soNos.join('\n')
        } else if (this.truckingInfo) {
          this.soNo = this.truckingInfo.soNo
        }
      }
    },
    loadTruckingInfoUsage(truckingInfo) {
      if (this.modifyUsageInEditMode) {
        this.usages = truckingInfo.usages
        return
      }
      if (!truckingInfo.uuid) {
        this.usages = []
        return
      }
      queryByTruckingInfo({ truckingInfoUuid: truckingInfo.uuid }).then(res => {
        this.usages = res.data
        this.loadContainerUsageResultHandler()
      })
    },
    loadContainerUsageResultHandler() {
      this.isAllowGridClick = true
      // 由于延迟加载，isTMSChanged() 会滞后
      this.txtTMSHint = ''
      if (this.usages != null) {
        for (const containerUsage of this.usages) {
          // type=2
          if (containerUsage.type >= 2) {
            this.txtTMSHint = this.$t('Message.ThisCarOrderIsChanged')
            return
          }
        }
      }
    },
    // 表单验证
    validate(isLastCheck = false) {
      if ((this.truckingInfo.carryingCmp === 0 || this.truckingInfo.carryingCmp === '') && (!isNaN(this.truckingInfo.truckingFee) && this.truckingInfo.truckingFee !== 0)) {
        if (isLastCheck) {
          throw new TabError(this.$t('Message.PleaseEnterTheShippingCompanyInformation'), 'tabTruckingForSe')
        } else {
          this.$message.warning(this.$t('Message.PleaseEnterTheShippingCompanyInformation'))
          return false
        }
      }
      if (isLastCheck && this.trucking) {
        const truckingMap = {}
        for (const trucking of this.trucking) {
          if (StrUtils.isEmpty(trucking.truckOrderNo)) {
            continue
          }
          if (truckingMap.hasOwnProperty(trucking.truckOrderNo)) {
            if (isLastCheck) {
              throw new TabError(this.$t('Message.SameJobtruckOrderNo'), 'tabTruckingForSe')
            } else {
              this.$message.warning(this.$t('Message.SameJobtruckOrderNo'))
              return false
            }
          } else {
            truckingMap[trucking.truckOrderNo] = true
          }
        }
      }
      return true
    },
    // 复制新增
    copyNewHandler() {
      try {
        if (!this.truckingInfo || !this.trucking || this.trucking.length < 1) {
          this.$message.warning('请选择指定数据')
          return
        }
        if (this.truckingInfo && this.isEdit) {
          this.setOldCarryingCmp()
          this.fillModel(false)
        }
        const item = this.truckingInfo
        if (this.validate()) {
          const trucking = new Trucking().fillDefaultValue().getData()
          trucking.jobUuid = this.job.uuid
          this.copyBasic(trucking, item)
          trucking.loadingDate = item.loadingDate
          trucking.actLoadingDate = item.actLoadingDate
          //	trucking.soNo = item.soNo;
          trucking.cubage = item.cubage
          trucking.plateNumber = item.plateNumber
          trucking.driverName = item.driverName
          trucking.driverPhone = item.driverPhone
          trucking.driverIdCard = item.driverIdCard
          trucking.loadingPortService = item.loadingPortService
          trucking.dischargingPortService = item.dischargingPortService
          trucking.dischargingWay = item.dischargingWay
          trucking.po = item.po
          trucking.zipCode = item.zipCode
          trucking.loadingAddress = item.loadingAddress
          trucking.returnContainerAddress = item.returnContainerAddress
          trucking.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
          trucking.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
          // 复制新增时 派车单号 和拖车费不复制
          trucking.truckingFee = 0.00
          this.trucking.push(trucking)
          this.truckingInfo = trucking
          this.setOldCarryingCmp()
          this.$nextTick(async() => {
            // 等待gridApi被赋值
            await ensureExecuteSuccess(() => this.topgridApi)
            this.setGridSelect(true)
            this.selectionChangeHandler({ data: trucking })
            // this.topgridApi.clearFocusedCell()
          })
        }
      } catch (err) {
        this.context.loading = false
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
    },
    // 新增
    addHandler() {
      if (this.truckingInfo && this.isEdit) {
        this.fillModel(false)
      }
      if (this.validate()) {
        const trucking = new Trucking().fillDefaultValue().getData()
        this.setDefaultPortService(trucking)
        if (this.trucking.length === 0) {
          trucking.quantity = this.job.quantityActual
          trucking.weight = this.job.weightActual
          trucking.cubage = this.job.cubageActual
        }
        trucking.jobUuid = this.job.uuid
        // 新增的时候门点也清空
        trucking.doorName = ''
        trucking.doorMan = ''
        trucking.doorManTel = ''
        trucking.doorAddr = ''
        trucking.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
        trucking.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
        this.trucking.push(trucking)
        this.truckingInfo = trucking
        this.$nextTick(() => {
          this.setGridSelect(true)
          this.selectionChangeHandler({ data: trucking })
        })
      }
    },
    // 删除
    delHandler() {
      // 去掉装箱信息和门点的关联（移至后端处理）
      for (const usage of this.job.containerUsages) {
        if (usage.truckingInfoUuid === this.truckingInfo.uuid) {
          usage.truckingInfoUuid = null
        }
      }
      this.truckingInfo.jobUuid = null
      if (this.job.trucking.length > 0) {
        this.job.carryingCmp = this.trucking[0].carryingCmp
      } else {
        this.job.carryingCmp = 0
      }
      // 移除
      const index = this.trucking.indexOf(this.truckingInfo)
      if (this.truckingInfo.uuid && this.delTruckingInfoUuids.indexOf(this.truckingInfo.uuid) < 0) {
        this.delTruckingInfoUuids.push(this.truckingInfo.uuid)
      }
      if (index > -1) {
        this.trucking.splice(index, 1)
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.topgridApi)
        this.setGridSelect(false)
        this.selectionChangeHandler({ data: this.truckingInfo })
      })
    },
    // 拖车费
    truckingFeeCharge() {
      // if (typeof newVal !== 'undefined') {
      //   if (newVal === this.truckingInfo.truckingFee) {
      //     return
      //   }
      //   this.oldTruckintFee = this.truckingInfo.truckingFee
      //   this.truckingInfo.truckingFee = newVal
      // }
      if (this.truckingInfo && this.isEdit) {
        this.createCharge(true, 'truckingFee')
      }
    },
    doorsChangeHandler(value, option) {
      this.truckingInfo.doorMan = ''
      this.truckingInfo.doorManTel = ''
      this.truckingInfo.doorAddr = ''
      this.truckingInfo.zipCode = ''
      if (option) {
        this.truckingInfo.doorMan = option.contact
        this.truckingInfo.doorManTel = option.phone
        this.truckingInfo.doorAddr = option.address
        this.truckingInfo.zipCode = option.zipCode
        if (option.remarks) this.truckingInfo.remarks = option.remarks
      }
      this.refreshGrid()
    },
    // 运输公司
    async carryingCmpChangeHandler() {
      if (!this.truckingInfo) return
      if (String(cache.config.get('ToExoSystem')) === 'XYCW' && this.job.etd) {
        if (this.truckingInfo.carryingCmp) {
          const data = DateUtils.addDays2(this.job.etd, -3)
          this.truckingInfo.loadingDate = data
        } else {
          this.truckingInfo.loadingDate = ''
        }
      }
      this.neednotReloadTelephone = false
      this.needReloadDriver = true
      this.job.carryingCmp = this.truckingInfo.carryingCmp
      this.truckingInfo.driver = ''
      this.truckingInfo.driverTel = ''
      this.carryingContacts = []
      await this.carringCapChange()
      this.driverInfomations = await JobUtils.getDriverInformationByCarryingCap(this.truckingInfo, this.truckingInfo.carryingCmp)
      if (this.toExoSystemHc) {
        this.driverAllSet[this.truckingInfo.carryingCmp] = this.driverInfomations || []
        this.refreshData(this.truckingInfo)
        this.refreshTruckingFee(this.truckingInfo)
      } else {
        this.refreshGrid()
        this.truckingFeeCharge()
      }
    },
    // 组装打印参数
    getPrintData(command) {
      const params = {}
      const reqKeys = this.job.requestSelectedKeys // todo 此处 调用不到 组件 selectedSpecialRequest this.getRequestSelectedKeys()
      params.jobuuid = this.job.uuid
      params.V3mail = this.V3mail
      params.JOB_UUID = this.job.uuid
      params.TRUCKING_UUID = StrUtils.isEmpty(this.truckingInfo.uuid) ? null : this.truckingInfo.uuid
      if (this.toExoSystemHc) {
        params.SHOW_TRUCK_ORDER_NO = StrUtils.isEmpty(this.truckingInfo.showTruckOrderNo) ? null : this.truckingInfo.showTruckOrderNo
      }
      params.USER_ID = this.currentUser.userId
      params.REQUEST_UUID = ((!reqKeys || reqKeys.length === 0) ? '' : reqKeys)
      if (this.job.lob === 'AI') {
        params.category = 'AIWT'
        params.ctx = new AirImportJob(this.job)
      } else {
        params.category = 'TRUCKING'
        params.ctx = new SeaExportJob(this.job)
      }
      if (command === 'PrintByFleet') {
        params.multiplePrint = true
        const multipleCarryingCmp = []
        const multipleTruckingUuid = []
        for (const item of this.trucking) {
          const carryingCmp = item.carryingCmp || 0
          if (multipleCarryingCmp.includes(carryingCmp)) {
            continue
          }
          multipleCarryingCmp.push(carryingCmp)
          multipleTruckingUuid.push(item.uuid)
        }
        params.multipleCarryingCmp = multipleCarryingCmp
        params.multipleTruckingUuid = multipleTruckingUuid
      }
      params.command = command
      this.$logger.log('params', params)
      return params
    },
    // 打印回调
    printedCallback(event) {
      this.$logger.log(event)
      const template = event.template
      const documentType = event.documentType
      if (template && documentType) {
        const objParams = { jobUuid: this.job.uuid, docKeys: documentType.uuid }
        this.$logger.log(objParams)
        updateTrackingForDocumentType(objParams)
      }
    },
    getSubmitData() {
      this.validateForm()
      this.fillModel(false)
      const job = { ...this.job }
      // 第一次创建（只有一条记录）
      if (this.trucking.length === 0 && this.truckingInfo && this.truckingInfo.jobUuid === this.job.uuid) {
        this.trucking.push(this.truckingInfo)
      }
      this.validateRequire(this.trucking)
      const charges = []
      if (this.job.charges && this.job.charges.length > 0) {
        for (const charge of this.job.charges) {
          if (!charge.isDirty) continue
          charges.push(charge)
        }
      }
      // charges: this.job.charges.filter(p => p.isDirty === true), // todo 在 费用tab 未打开的情况下 需要保持charges
      const result = {
        job,
        truckingInfo: this.trucking,
        delTruckingInfoUuids: this.delTruckingInfoUuids
      }
      if (this.modifyUsageInEditMode) {
        result.unBindContainerUsageUuids = this.unBindContainerUsageUuids
      }
      if (charges.length > 0) result.charges = charges
      return result
    },
    validateForm() {
      this.validate(true)
    },
    fillModel(isFinal = false) {
      // 判断门点 手工输入非 选择
      const door = this.doorList.find(item => item.name === this.truckingInfo.doorName)
      if (!door) { // new door
        this.needSaveCustomer = true
        this.newDoor()
      }
      // 日期组装
      /* if (this.truckingInfo.loadingDate) {
        this.truckingInfo.loadingDate = this.truckingInfo.loadingDate.substr(0, 10) + ' ' + this.truckingInfo.loadingDateHour + ':' + this.truckingInfo.loadingDateMinutes
        this.truckingInfo.loadingDate = ColumnUtils.formateDateToString(this.truckingInfo.loadingDate, 'yyyy-MM-dd hh:mm:ss')
      }*/
      // eslint-disable-next-line no-empty
      if (this.job.multiplePickups) {
      } else {
        this.truckingInfo.soNo = ''
      }
      this.createCharge(isFinal)
    },
    validateRequire(truckingList) {
      // UI自定义中用到
    },
    newDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (inputDoor) {
        return
      }

      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: companyCache.uuid
      }
      addSites(door)
    },
    async createCharge(isFinal, source) {
      if (!this.truckingInfo.truckingFee) {
        this.$nextTick(() => {
          this.truckingInfo.truckingFee = 0
        })
      }
      if (!isFinal) {
        return
      }
      const chargeCount = this.getCost()
      const amount = this.truckingInfo.truckingFee
      const truckingCount = this.job.trucking ? this.job.trucking.length : 0
      let charge = null
      let isCreate = true
      if (this.job.charges && this.job.charges.length > 0) {
        for (const c of this.job.charges) {
          if (this.action === 'copy' && !this.job.uuid) { // 复制的时候，用运输公司匹配拖车费
            if (!c.receivable && this.oldCarryingCmp > 0 && c.accountId === this.oldCarryingCmp) {
              isCreate = false
              charge = c
              break
            }
          } else {
            if (c.truckOrderNo === this.truckingInfo.truckOrderNo) {
              isCreate = false
              charge = c // 先录费用后录拖车使用
              break
            }
          }
        }
      }
      const shared = charge && (charge.shared || (charge.shareScheme && parseInt(charge.shareScheme) !== 0)) // 是否已分摊
      if (source === 'truckingFee' &&
          charge &&
          charge.verifiedAmount === 0 &&
          StrUtils.isEmpty(charge.billingUuid) &&
          StrUtils.isEmpty(charge.billingPaymentUuid) &&
          StrUtils.isEmpty(charge.invoiceUuid) &&
          charge.uuid &&
          !(charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared)
      ) {
        await this.truckingFeeConfirm(source)
        return
      }
      const chargeItemId = parseInt(cache.config.get('TruckingFeeCode')) // TRUCKING_FEE_CODE;
      const chargeItem = ChargeItem.getChargeItemById(chargeItemId)
      if (chargeItem && chargeItem.active && truckingCount > chargeCount && amount > 0 && isCreate) {
        charge = this.createNewCharge()
        charge.truckOrderNo = this.truckingInfo.truckOrderNo
        charge.chargeItemId = chargeItemId // TRUCKING_FEE_CODE;
        if (chargeItem.taxRate > 0) {
          charge.taxRate = chargeItem.taxRate
        }
        if (chargeItem.measure !== null && chargeItem.measure !== '') {
          charge.measure = chargeItem.measure
        }
        charge.unitPriceIncludeTax = parseInt(cache.config.get('InputIncludingTaxUnitPrice')) === 2
        // 其他tab 有charge 提交 需合并或其他方案待处理
        if (!this.job.charges) {
          this.job.charges = []
        }
        charge.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        charge.isDirty = true
        this.job.charges.push(charge)
      }
      if (this.toExoSystemHc && charge) {
        charge.createdBy = this.truckingInfo.prcCreatedBy
      }
      if (charge && charge.verifiedAmount === 0 && StrUtils.isEmpty(charge.billingUuid) && StrUtils.isEmpty(charge.billingPaymentUuid) && StrUtils.isEmpty(charge.invoiceUuid)) {
        if (!isNaN(amount) && amount > 0) {
          charge.accountId = this.truckingInfo.carryingCmp
          const accountIds = [{
            accountId: charge.accountId
          }]
          await this.initSettlementAgentsMap(accountIds)
          await this.getSettlementByCompanyId(charge)
          charge.changer = this.$store.getters.userId
          if (charge.uuid) {
            if (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus && !shared) {
              charge.unitRate = amount
            }
          } else {
            charge.unitRate = amount
          }
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, parseFloat((charge.unitRate * charge.quantity).toFixed(2)), charge.taxRate, true)
          }
          charge.isDirty = true
        } else {
          if (!shared && !(await this.truckingFeeConfirm(source))) {
            return
          }
          if (!shared && (!charge.uuid || (charge.chargeState === 0 && !charge.confirmState && !this.job.payableChargeLockedStatus))) {
            charge.unitRate = 0
            charge.changer = this.$store.getters.userId
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, 0, charge.taxRate)
            } else {
              ChargeUtils.calculateTax(charge, 0, charge.taxRate, true)
            }
            charge.isDirty = true
          }
        }
      }
      // 设置开票抬头
      if (charge && charge.accountId && charge.accountId > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle([charge])
      }
      /* if (needSaveCustomer) {
          var customer:Company = Company.getCompanyById(job.customerId);
          if (customer)
            customer.save2(saveCustomerResult, saveCustomerFault);
        }*/
      this.context.reloadCharge = true
    },
    // 初始化结算代理s
    async initSettlementAgentsMap(charges) {
      // 获取唯一的 accountId 列表
      const accountIds = Array.from(new Set(charges.map(p => p.accountId)))

      // 如果没有需要处理的 accountId，直接返回
      if (!accountIds || accountIds.length <= 0) return

      // 从接口获取结算代理数据
      const settlementAgentMap = await getSettlementAgentsByCmpIdxList(accountIds).then((res) => res.data)

      // 如果接口返回的数据为空，直接返回
      if (!settlementAgentMap) return

      // 将接口返回的数据转换为 Map 并放入 customerSettlementAgentMap 中
      Object.entries(settlementAgentMap).forEach(([accountId, agentData]) => {
        this.currentViewCacheData.customerSettlementAgentMap.set(Number(accountId), agentData)
      })
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      if (!chargeAccount) {
        return
      }
      if (this.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
        const staticOptions = this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
        const index = staticOptions.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          if (chargeAccount) {
            staticOptions.push(chargeAccount)
          }
          this.currentViewCacheData.customerSettlementAgentMap.set(accountId, staticOptions)
        }
        charge.settlementAgentId = staticOptions[0].cmpIdx
      } else {
        const res = await getSettlementAgentsByCmpIdx(charge.accountId)
        let dbSettlementAgents = res.data
        if (!dbSettlementAgents) dbSettlementAgents = []
        if (chargeAccount) {
          const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
          if (index < 0) {
            dbSettlementAgents.push(chargeAccount)
          }
        }
        charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
        this.currentViewCacheData.customerSettlementAgentMap.set(accountId, dbSettlementAgents)
      }
    },
    createNewCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.quantity = 1
      charge.localCurrency = this.localCurrency
      charge.currency = this.localCurrency
      charge.exchangeRate = 1
      charge.measure = 'NML'
      charge.receivable = false
      charge.oversea = false
      charge.verifiedAmount = 0
      charge.inputDate = new Date()
      charge.inputBy = this.currentUser.userId
      charge.branchId = this.$store.getters.currentOfficeId

      charge.inputByDep = this.job.opDepartment
      charge.businessDate = this.job.businessDate

      // 此处增加标识，费用页签再保存会导致费用重复生成
      charge.createdByOther = true
      return charge
    },
    async truckingFeeConfirm(source) {
      if ((this.job.lob === 'SE' || this.job.lob === 'AE' || this.job.lob === 'RE') && source === 'truckingFee') {
        const flag = await this.$confirm(this.$t('SeaExport.IfToTheCurrentIt'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('constant.yes'),
          cancelButtonText: this.$t('constant.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          this.truckingInfo.truckingFee = this.oldTruckintFee
          return false
        }
      }
      return true
    },
    // get job's trucking charge
    getCost() {
      // TRUCKING_FEE_CODE  默认拖车费
      const chargeCode = parseInt(cache.config.get('TruckingFeeCode'))
      let count = 0
      for (const charge of this.job.charges) {
        if (charge.chargeItemId === chargeCode && !charge.receivable) {
          count++
        }
      }
      return count
    },
    /**
       * 复制属性
       */
    copyBasic(target, source) {
      target.carryingCmp = source.carryingCmp
      target.doorAddr = source.doorAddr
      target.doorMan = source.doorMan
      target.doorManTel = source.doorManTel
      target.doorName = source.doorName
      target.cubage = source.cubage
      target.quantity = source.quantity
      target.weight = source.weight
      target.remarks = source.remarks
      // fix Bug 1750
      //			loadingDate = source.loadingDate;
      target.driver = source.driver
      target.driverTel = source.driverTel
    },
    // 除了第一个记录外 其他记录删除
    multiPickupsChangeHandler() {
      if (!this.job.multiplePickups && this.trucking && this.trucking.length > 1) {
        const len = this.trucking.length
        for (let i = len - 1; i >= 1; i--) {
          // 移除
          const index = this.trucking.indexOf(this.trucking[i])
          if (this.trucking[i].uuid && this.delTruckingInfoUuids.indexOf(this.trucking[i].uuid) < 0) {
            this.delTruckingInfoUuids.push(this.trucking[i].uuid)
          }
          this.trucking.splice(index, 1)
        }
      }
      if (this.truckingInfo) {
        this.fillModel()
      }
      this.checkDefaultTrucking()
      this.changePickupsOrCabinets('Pickups')
    },
    // 切换多门点或多柜
    changePickupsOrCabinets(value) {
      if (this.job.lob === 'SE') {
        if (value === 'Pickups') {
          this.job.multipleCabinets = false
        } else if (value === 'Cabinets') {
          this.job.multiplePickups = false
        }
      }
    },
    refreshGrid() {
      if (this.topgridApi) {
        this.topgridApi.refreshCells({ force: true })
      }
      if (this.hcInfo && this.hcInfo.gridApi) {
        this.hcInfo.gridApi.refreshCells({ force: true })
      }
      if (this.hcDoor && this.hcDoor.gridApi) {
        this.hcDoor.gridApi.refreshCells({ force: true })
      }
    },
    linkUsageClickHandler() {
      if (this.usages && this.usages.length > 0) {
        for (const item of this.usages) {
          if (!StrUtils.isEmpty(item.code)) {
            this.$message.warning(this.$t('Message.ThisCarOrderIsSendedNoAddUsage'))
            return
          }
        }
      }
      if (this.modifyUsageInEditMode) {
        const usages = this.job.containerUsages
        if (usages && usages.length > 0) {
          this.containerUsageDialog.data = usages.filter(p => (!p.truckingInfoUuid || this.unBindContainerUsageUuids.indexOf(p.uuid) > -1) && !p.bindedTrucking)
        } else {
          this.containerUsageDialog.data = []
        }
      }
      this.containerUsageDialog.visible = true
    },
    // 选择装箱信息后的处理
    selectContainerUsageHandler(selectedData) {
      if (this.modifyUsageInEditMode) {
        const uuids = []
        selectedData.forEach(p => {
          if (!p.uuid) {
            p.tempUuid = uidUtil.createUID()
          } else {
            uuids.push(p.uuid)
          }
          p.bindedTrucking = true
          this.truckingInfo.usages.push(p)
        })
        this.unBindContainerUsageUuids = this.unBindContainerUsageUuids.filter(p => uuids.indexOf(p) === -1)
        this.$nextTick(() => {
          this.gridApi.refreshCells({ force: true })
        })
      } else {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        // 正常情况用下面就行，但是海创涉及上面列表页面，需要onshow刷新
        if (!this.toExoSystemHc) {
          // 重新加载 装箱信息列表
          if (!this.isEdit && this.job && this.job.containerUsages) {
            this.job.containerUsages = ''
            this.job.containers = ''
            new Job(this.job).loadJobRelated({ containerUsages: true, containers: true })
          }
          this.loadTruckingInfoUsage(this.truckingInfo)
          this.refreshTruckingContainerNo()
        }
      }
    },
    saveContainerUsageHandler(event) {
      if (event) {
        this.doSaveContainerUsageHandler(event.truckingInfoId)
      }
    },
    doSaveContainerUsageHandler(truckingInfoId) {
      // 获取当前选中数据
      const hcDoorTrucking = this.hcDoorTrucking.find(p => p.uuid === truckingInfoId)
      const hcInfoTrucking = this.hcInfoTrucking.find(p => p.showTruckOrderNo === hcDoorTrucking.showTruckOrderNo)
      // uuid相同 就是页面第一条数据
      if (hcDoorTrucking && hcInfoTrucking && hcDoorTrucking.uuid === hcInfoTrucking.uuid) {
        const params = {
          jobUuid: this.job.uuid,
          truckingUuid: truckingInfoId
        }
        matchingPriceFunc(params).then(res => {
          // 费用页签也刷新
          this.context.reloadCharge = true
          this.onShow(this.job, true)
        })
      }
    },
    // 刷新门点箱号
    refreshTruckingContainerNo() {
      containerUsagesByJobUuid({ jobUuid: this.job.uuid }).then(res => {
        this.setContainerNo(this.trucking, res.data)
        this.topgridApi.refreshCells({ force: true })
      })
    },
    // 移除装箱信息
    delLinkUsageClickHandler() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        return
      }
      this.$confirm(this.$t('Message.SureYouRemoveThisNData1') + ' ' + selections.length + ' ' + this.$t('Message.SureYouRemoveThisNData2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        let n = true
        for (const usage of selections) {
          if (!(usage.truckStatus === '' || usage.truckStatus == null || usage.truckStatus === '03' ||
              usage.truckStatus === '05' || usage.truckStatus === '11' || usage.truckStatus === '00')) {
            this.$message.warning(this.$t('Message.ThisBoxIsNotAllowedToBeDeleted'))
            n = false
            return
          }
        }
        if (n) {
          if (this.modifyUsageInEditMode) {
            const uuids = []
            const tempUuids = []
            selections.forEach(p => {
              p.bindedTrucking = false
              if (p.uuid) {
                uuids.push(p.uuid)
              } else {
                tempUuids.push(p.tempUuid)
              }
            })
            this.unBindContainerUsageUuids.push(...uuids)
            this.truckingInfo.usages = this.truckingInfo.usages.filter(p => !tempUuids.includes(p.tempUuid) && !uuids.includes(p.uuid))
            this.usages = this.truckingInfo.usages
            this.gridApi.refreshCells({ force: true })
          } else {
            const containerUsagesIds = Array.from(selections, p => p.uuid).reduce((a, b) => a + ',' + b)
            delContaierUsageLinkedTruckingInfo({ containerUsagesIds: containerUsagesIds }).then(res => {
              this.$message.success(this.$t('Message.DeleteSuccessfully'))
              // 正常情况用下面就行，但是海创涉及上面列表页面，需要onshow刷新
              if (this.toExoSystemHc) {
                this.doSaveContainerUsageHandler(this.truckingInfo.uuid)
              } else {
                if (!this.isEdit && this.job && this.job.containerUsages) {
                  this.job.containerUsages = ''
                  this.job.containers = ''
                  new Job(this.job).loadJobRelated({ containerUsages: true, containers: true })
                }
                // 重新加载 装箱信息列表
                this.containerUsages = []
                this.loadTruckingInfoUsage(this.truckingInfo)
                this.refreshTruckingContainerNo()
              }
            })
          }
        }
      })
    },
    // 互联派车按钮组
    btnConnectedTruckClickHandler() {
      if (this.command1 === this.$t('SeaExport.DispatchTuckOrder')) {
        this.dispatchTruckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.ModifyTuckOrder')) {
        this.modifyTuckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.RevokeTuckOrder')) {
        // 撤单
        this.revokeTuckOrderClickHandler()
      } else if (this.command1 === this.$t('SeaExport.SearchTuckOrder')) {
        // 查询派车单
        this.getTruckOrderClickHandler()
      }
      // cargo 此按钮未开放 前端 注释了<!--<fx:Object label="上传附件"/>-->
      /* else if (this.command1 === this.$t('SeaExport.DispatchTuckOrder')) {
          uploadFile();
        }*/
    },
    // 发送派车单接口
    dispatchTruckOrderClickHandler() {
      if (this.truckingInfo == null || StrUtils.isEmpty(this.truckingInfo.uuid) || this.truckingInfo.carryingCmp === 0) {
        this.$message.warning(this.$t('Message.PleaseEnterFleetInformatio'))
        return
      }
      if (this.usages == null || this.usages.length === 0) {
        this.$message.warning(this.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      // CARGO-6783，派单成功后，在当票继续作其他信息修改后，在保存，会冲掉派单标记
      for (const containerUsage of this.usages) {
        // if (!StrUtils.isEmpty(containerUsage.code)) {
        if (!StrUtils.isEmpty(containerUsage.truckStatus) && containerUsage.truckStatus !== SeaExportConstants.TRUCKING_UN_DISPATCHED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderIsSended'))
          return
        }
      }
      // 派单成功之后，不可以再次派单，只能通过改单进行修改请求。
      //				if (truckingInfo != null && truckingInfo.sendState >= 1)
      //				{
      //					MessageDialog.warning(resourceManager.getString('Message','ThisCarOrderIsSended'),resourceManager.getString('Message','Warning'));
      //					return;
      //				}

      this.$confirm(this.$t('Message.AreYouSureYouWantToSendACarOrder'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        // 派车类型默认值: 1=互联派车  2=鸭嘴兽
        const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
        if (value === '2') {
          sendTruckOrder2Duck(this.truckingInfo).then(res => {
            this.sendTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        } else {
          sendTruckOrder(this.truckingInfo).then(res => {
            this.sendTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        }
      }
      )
    },
    sendTruckingInfoHandler(result) {
      const msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.DispatchSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.DispatchFailed'))
      }
    },
    // 更改派车单
    modifyTuckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()
      if (selModifiedContainerUsage) {
        // 派单成功之后，不可以再次派单，只能通过改单进行修改请求。
        // if (truckingInfo != null && truckingInfo.sendState == 0)
        // CARGO-6783，派单成功后，在当票继续作其他信息修改后，在保存，会冲掉派单标记
        // if (StrUtils.isEmpty(selModifiedContainerUsage.code))
        if (StrUtils.isEmpty(selModifiedContainerUsage.truckStatus) || selModifiedContainerUsage.truckStatus === SeaExportConstants.TRUCKING_UN_DISPATCHED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderCanOnlyBeModifiedAfterSending'))
          return
        }

        this.$confirm(this.$t('Message.AreYouSureYouWantToModifyACarOrder'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
          if (value === '2') {
            return
          } else {
            this.loading = getLoading4Cxt(this)
            sendModifiedTruckOrder({ truckingInfo: this.truckingInfo, containerUsage: selModifiedContainerUsage }).then(res => { this.sendModifiedTruckingInfoHandler(res.data) }).finally(() => { this.loading.close() })
          }
        })
      }
    },
    sendModifiedTruckingInfoHandler(result) {
      var msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.ModifiedTruckOrderSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.ModefiedTruckOrderFaild'))
      }
    },
    // 撤单
    revokeTuckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()
      if (selModifiedContainerUsage) {
        // CARGO-6454，客户撤单条件：此订单是未接单状态
        if (!StrUtils.isEmpty(selModifiedContainerUsage.truckStatus) && selModifiedContainerUsage.truckStatus !== SeaExportConstants.TRUCKING_UN_APPROVED.code) {
          this.$message.warning(this.$t('Message.ThisCarOrderCanOnlyBeRevokedIsUnApproved'))
          return
        }

        this.$confirm(this.$t('Message.AreYouSureYouWantToRevokeACarOrder'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
          if (value === '2') {
            return
          } else {
            this.loading = getLoading4Cxt(this)
            revokeTruckOrder({ truckingInfo: this.truckingInfo, containerUsage: selModifiedContainerUsage }).then(res => {
              this.sendRevokeTruckingInfoHandler(res.data)
            }).finally(() => { this.loading.close() })
          }
        })
      }
    },
    sendRevokeTruckingInfoHandler(result) {
      const msg = result
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(this.$t('Message.RevokeTruckOrderSuccess'))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.RevokeTruckOrderFaild'))
      }
    },
    // 查询派车单
    getTruckOrderClickHandler() {
      const selModifiedContainerUsage = this.getSelectedModifiedTruckData()

      if (selModifiedContainerUsage) {
        // 派车类型默认值: 1=互联派车  2=鸭嘴兽
        const value = String(cache.config.get('DispatchTruckTypeDefaultValue'))
        if (value === '2') {
          return
        } else {
          this.loading = getLoading4Cxt(this)
          getTruckOrder({ truckingInfo: this.truckingInfo, containerUsage: selModifiedContainerUsage }).then(res => {
            this.getTruckingInfoHandler(res.data)
          }).finally(() => { this.loading.close() })
        }
      }
    },
    getTruckingInfoHandler(msg) {
      if (msg) {
        if (msg.indexOf('1') >= 0) {
          this.$message.success(msg.replace('1', ''))
          this.loadTruckingInfoUsage(this.truckingInfo)
        } else {
          this.$message.info(msg)
        }
      } else {
        this.$message.error(this.$t('Message.SendFailed'))
      }
    },
    getSelectedModifiedTruckData() {
      let modifiedUsage = null
      if (this.usages === null || this.usages.length === 0) {
        this.$message.warning(this.$t('Message.NoAssociatedContainerInfo'))
        return
      }
      const selUsages = this.gridApi.getSelectedRows()
      if (selUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
      } else if (selUsages.length > 1) {
        this.$message.warning(this.$t('Message.OnlySelectOneData'))
      } else {
        modifiedUsage = selUsages[0]
      }
      return modifiedUsage
    },
    // 派车单日志
    showTuckOrderLogClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      queryTuckOrderLog({ containerUsageUuid: rows[0].uuid }).then(res => { this.queryTuckOrderLogResultHandler(res.data) })
    },
    queryTuckOrderLogResultHandler(data) {
      this.truckOrderLogDialog.rowData = data
      this.truckOrderLogDialog.visible = true
    },
    // 上传附件
    uploadFileClickHandler(value) {
      // CARGO-6902，编辑状态下，箱记录的附件上传会异常，导致刚录入的拖车费没了
      if (this.isEdit) {
        return
      }
      this.uploadCommonFileDialog.model = { uuid: value }
      this.uploadCommonFileDialog.visible = true
    },
    // 费用确认
    auditUrlClickHandler(value) {
      if (value) {
        window.open(value)
      }
    },
    // 装箱信息编辑
    onTimeCellChange(params) {
      // 记录装箱信息 用于保存
      const item = params.data
      if (item && item.container && item.container.uuid) {
        const key = params.field || params.colDef.colId
        switch (key) {
          case 'estimatedDeliveryTime':
            item.container.estimatedDeliveryTime = item.estimatedDeliveryTime
            break
          case 'estimatedArrivalTime':
            item.container.estimatedArrivalTime = item.estimatedArrivalTime
            break
          default :
            break
        }
        // 去重（更新上次的修改）
        const index = this.containers.findIndex(p => p.uuid === item.container.uuid)
        if (index > -1) {
          this.containers.splice(index, 1)
        }
        this.containers.push(item.container)
        // 赋值给保存
        this.truckingInfo.containers = this.containers
      }
      this.gridApi.refreshCells({ force: true })
    },
    // 拖车费编辑
    onCellChange(params) {
      const item = params.data
      item.truckingFee = ColumnUtils.number2ColumnLabelFunc(NumberUtils.roundHalfUp(item.truckingFee, 2))
      this.gridApi.refreshCells({ force: true })
      // 实现 itemEditEndHandler
      this.truckingFeeCharge()
      this.$nextTick(() => {
        this.truckingFeeSum()
        // 记录装箱明细的 拖车费 用于保存
        // 去重（更新上次的修改）
        const index = this.containerUsages.findIndex(p => p.uuid === item.uuid)
        if (index >= 0) {
          this.containerUsages.splice(index, 1)
        }
        this.containerUsages.push({ uuid: item.uuid, truckingFee: item.truckingFee })
        // 赋值给保存
        this.truckingInfo.containerUsages = this.containerUsages
      })
    },
    truckingFeeSum() {
      let truckingFeeSum = 0
      for (const u of this.usages) {
        if (!isNaN(u.truckingFee)) {
          truckingFeeSum += u.truckingFee
        }
      }
      if (truckingFeeSum > 0) {
        this.truckingInfo.truckingFee = truckingFeeSum
      }
    },
    // 派车单日志
    showErrorLogClickHandler(tosTaskId) {
      if (!StrUtils.isEmpty(tosTaskId)) {
        queryEventLogList({ taskId: tosTaskId }).then(res => { this.queryErrorLogResultHandler(res.data) })
      }
    },
    queryErrorLogResultHandler(data) {
      if (data && data.length > 0) {
        this.errorLogDialog.rowData = data
        this.errorLogDialog.visible = true
      } else {
        this.$message.info('暂无相关信息')
      }
    },
    selectContactBlur(event) {
      if (event && event.target && event.target.value) {
        this.truckingInfo.driver = event.target.value
      }
      this.refreshGrid()
    },
    endTabHandler() {
      this.job.truckingPage = true
    },
    // 预计出仓时间、预计进港时间显示
    estimatedDisplayFunction(params, field) {
      if (params.data && params.data.container) {
        const tempTime = params.data.container[field]
        return tempTime ? ColumnUtils.dateTimeLabelFunc(tempTime) : ''
      }
      return ''
    },
    loadTruckingRecord(truckingInfo) {
      if (!truckingInfo.uuid) {
        this.truckingRecords = []
        return
      }
      queryTruckingByTruck({ truckingInfoUuid: truckingInfo.uuid }).then(res => {
        this.truckingRecords = res.data
      })
    },
    // 多柜模式-点击添加装箱信息
    linkTruckRecordHandler() {
      this.containerTruckingRecordDialog.visible = true
    },
    // 移除装箱信息
    dellinkTruckRecordHandler() {
      const selections = this.gridApi.getSelectedRows()
      if (selections.length === 0) {
        return
      }
      this.$confirm(this.$t('Message.SureYouRemoveThisNData1') + ' ' + selections.length + ' ' + this.$t('Message.SureYouRemoveThisNData2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        const keysList = []
        for (const item of selections) {
          keysList.push(item.uuid)
        }
        delTruckingRecord({ recordIdList: keysList }).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          // 重新加载 装箱信息列表
          this.loadTruckingRecord(this.truckingInfo)
        })
      })
    },
    // 多柜模式-选择装箱信息后
    selectTruckingRecordHandler() {
      this.$message.success(this.$t('Message.SaveSuccessfully'))
      // 重新加载 装箱信息列表
      this.loadTruckingRecord(this.truckingInfo)
    },
    // 多柜模式-导出做箱信息
    exportTruckExcelData() {
      if (this.truckingRecords.length > 0) {
        ExportUtils.downloadTruckExcelTemplate('CustomerStoreImportTemplate.xls', encodeURIComponent(this.truckingInfo.uuid))
      } else {
        this.$message.warning(this.$t('Message.TruckingNotExist'))
      }
    },
    // 多柜模式-下载导入结果
    exportErrorExcel() {
      // 从云存储上下载文件
      if (!this.importExcelResultID) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      // const storageURL = cache.config.get('StorageURL')
      const url = `${URL.common.findByFileId}/${this.importExcelResultID}?sessionId=${this.sessionId}`
      window.open(url)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // 多柜模式-导入做箱信息
    importTruckDataExcel(item) {
      const params = {
        file: item.file,
        truckingInfoUuid: this.truckingInfo.uuid
      }
      importTruckExcelData(params).then(res => {
        if (!res.data) {
          this.$message.success(this.$t('SeaExport.ImportSuccess'))
        } else {
          this.$message.warning(this.$t('SeaExport.ImportFaildAndDownFile'))
          this.importExcelResultID = res.data
        }
        this.uploadSuccessUsage(res.data)
      })
    },
    refreshInfo(no = '', isD = false) {
      this.hcDoorTrucking = []
      this.hcInfoTrucking = []
      const noMap = new Set()
      for (const data of this.trucking) {
        // 兼容历史数据
        if (!data.showTruckOrderNo) {
          data.showTruckOrderNo = data.truckOrderNo
        }
        if (!noMap.has(data.showTruckOrderNo)) {
          this.hcInfoTrucking.push(data)
          noMap.add(data.showTruckOrderNo)
        }
      }
      // 默认选中第一行
      if (this.hcInfoTrucking && this.hcInfoTrucking.length > 0) {
        setTimeout(() => {
          let top = 0
          // 找到对应数据的行
          let oneData = null
          this.hcInfo.gridOptions.api.forEachLeafNode((node) => {
            if (no && node.data['showTruckOrderNo'] === no) {
              top = node.childIndex
              oneData = node.data
            }
            if (!no && node.childIndex === 0) {
              oneData = node.data
            }
          })
          this.hcTruckingInfo = oneData
          // 设置选中行
          this.hcInfo.gridOptions.api.setFocusedCell(top, this.hcInfo.gridOptions.api.columnController.getAllDisplayedColumns()[0])
          this.refreshHcInfo(oneData.showTruckOrderNo, isD)
        })
      }
    },
    refreshHcInfo(showTruckOrderNo, isD) {
      this.hcDoorTrucking = this.trucking.filter(p => p.showTruckOrderNo === showTruckOrderNo)
      // 删除时，重新给序号排序
      if (isD && this.hcDoorTrucking) {
        this.hcDoorTrucking.forEach((data, index) => {
          data.deliveryNo = index + 1
        })
      }
      setTimeout(() => {
        this.hcDoor.gridOptions.api.forEachLeafNode((node) => {
          if (node.childIndex === 0) {
            this.truckingInfo = node.data
            this.setOldCarryingCmp()
          }
        })
        if (this.isEdit) {
          if (this.modifyUsageInEditMode) {
            this.hcDoor.gridOptions.api.setFocusedCell(0, this.hcDoor.gridOptions.api.columnController.getAllDisplayedColumns()[0])
          } else {
            this.hcDoor.gridOptions.api.setFocusedCell(0)
          }
        } else {
          // 用这个页面列表会闪一下
          this.hcDoor.gridOptions.api.setFocusedCell(0, this.hcDoor.gridOptions.api.columnController.getAllDisplayedColumns()[0])
        }
        // 设置箱子信息
        this.selectionChangeHandler({ data: this.truckingInfo })
      })
    },
    async getAllSoNoHandler() {
      this.soNoAllSet = new Set()
      if (this.job.soNo) {
        // 根据换行符分隔
        const soNoArr = this.job.soNo.split('\n')
        for (const soNo of soNoArr) {
          const cData = {}
          cData['soNo'] = soNo
          cData['code'] = soNo
          cData['chineseName'] = soNo
          this.soNoAllSet.add(cData)
        }
      }
    },
    async onPlateNumberChange(params) {
      const item = params.data
      const driverInfo = this.driverInfomations.filter(p => p.plateNumber === item.plateNumber)
      if (driverInfo && driverInfo.length > 0) {
        item.driverPhone = driverInfo[0].driverPhone
        item.driverIdCard = driverInfo[0].driverIdCard
        item.deliveryArea = driverInfo[0].deliveryArea
      }
      this.refreshData(item)
      this.refreshGrid()
    },
    async onHcInfoCellChange(params) {
      const item = params.data
      const field = params.colDef.field
      const hcDoorTrucking = this.trucking.filter(p => p.showTruckOrderNo === item.showTruckOrderNo)
      if (hcDoorTrucking) {
        for (const data of hcDoorTrucking) {
          if (field === 'soNo') {
            if (data.soNo) {
              data.soNo = data.soNo.join()
            } else {
              data.soNo = ''
            }
          } else {
            data[field] = item[field]
          }
        }
      }
      if (field === 'carryingCmp') {
        await this.carryingCmpChangeHandler()
      }
      if (field === 'truckingFee') {
        this.truckingFeeCharge()
      }
      this.refreshGrid()
    },
    refreshData(item) {
      const hcDoorTrucking = this.trucking.filter(p => p.showTruckOrderNo === item.showTruckOrderNo)
      if (hcDoorTrucking) {
        for (const data of hcDoorTrucking) {
          data.carryingCmp = item.carryingCmp
          data.driverTel = item.driverTel
          data.driver = item.driver
          data.plateNumber = item.plateNumber
          data.driverPhone = item.driverPhone
          data.driverIdCard = item.driverIdCard
          data.deliveryArea = item.deliveryArea
        }
      }
    },
    onHcDoorCellChange(params) {
      const item = params.data
      item.doorMan = ''
      item.province = ''
      item.cityNew = ''
      item.county = ''
      item.town = ''
      item.cityNewStr = ''
      item.countyStr = ''
      item.townStr = ''
      item.doorManTel = ''
      item.doorAddr = ''
      if (!item.doorName) {
        // 这里校验只有第一个门点 才能触发拖车费变动
        const hcDoorTrucking = this.hcDoorTrucking.find(p => p.truckOrderNo === item.truckOrderNo)
        const hcInfoTrucking = this.hcInfoTrucking.find(p => p.showTruckOrderNo === item.showTruckOrderNo)
        if (hcDoorTrucking && hcInfoTrucking && hcDoorTrucking.truckOrderNo === hcInfoTrucking.truckOrderNo && hcDoorTrucking.truckingFee !== 0) {
          this.clearTruckingFee(hcDoorTrucking)
          this.refreshGrid()
          this.truckingFeeCharge()
        } else {
          this.refreshGrid()
        }
        return
      }
      const option = this.doorList.filter(p => p.name === item.doorName)
      if (option && option.length > 0) {
        item.doorMan = option[0].contact
        item.province = option[0].province
        item.cityNew = option[0].cityNew
        item.county = option[0].county
        item.town = option[0].town
        item.cityNewStr = option[0].cityNewStr
        item.countyStr = option[0].countyStr
        item.townStr = option[0].townStr
        item.doorManTel = option[0].phone
        item.doorAddr = option[0].address
        if (option[0].remarks) {
          item.remarks = option[0].remarks
        }
      }
      // 新增的门点不需要下面的逻辑
      this.refreshTruckingFee(item)
    },
    refreshTruckingFee(item) {
      // 这里校验只有第一个门点 才能触发拖车费变动
      const hcDoorTrucking = this.hcDoorTrucking.find(p => p.truckOrderNo === item.truckOrderNo)
      const hcInfoTrucking = this.hcInfoTrucking.find(p => p.showTruckOrderNo === item.showTruckOrderNo)
      if (hcDoorTrucking && hcInfoTrucking && hcDoorTrucking.truckOrderNo === hcInfoTrucking.truckOrderNo) {
        // 需要填写运价类型
        if (!this.job.rateType) {
          this.clearTruckingFee(hcDoorTrucking)
          this.refreshGrid()
          return
        }
        const data = {
          jobUuid: item.jobUuid,
          lob: this.job.lob,
          opOffice: this.job.opOffice,
          loadingPortCode: this.job.loadingPortCode,
          truckingUuid: item.uuid,
          carryingCmp: item.carryingCmp,
          province: item.province,
          cityNew: item.cityNew,
          county: item.county,
          town: item.town,
          rateType: this.job.rateType,
          doorAddr: item.doorAddr
        }
        matchingPricePageFunc(data).then(res => {
          if (res.data) {
            const data = res.data
            hcDoorTrucking.truckingFee = data.truckingFee
            hcDoorTrucking.priceUuid = data.priceUuid
            hcDoorTrucking.containerDesc = data.containerDesc
            hcDoorTrucking.prcCreatedBy = data.prcCreatedBy
          } else {
            this.clearTruckingFee(hcDoorTrucking)
          }
          this.truckingFeeCharge()
        }).finally(() => {
          this.refreshGrid()
        })
      } else {
        this.refreshGrid()
      }
    },
    clearTruckingFee(hcDoorTrucking) {
      hcDoorTrucking.truckingFee = 0.0
      hcDoorTrucking.priceUuid = ''
      hcDoorTrucking.containerDesc = ''
    },
    onDeliveryNoCellChange(params) {
      const item = params.data
      if (Number(item.deliveryNo) < 1) {
        item.deliveryNo = 1
      }
      this.refreshGrid()
    },
    selectionHcChangeHandler(event) {
      if (!event.data) {
        return
      }
      if (!this.hcTruckingInfo || (event.data.showTruckOrderNo !== this.hcTruckingInfo.showTruckOrderNo)) {
        this.hcTruckingInfo = event.data
        this.refreshHcInfo(this.hcTruckingInfo.showTruckOrderNo, false)
      }
    },
    selectionHcDoorChangeHandler(event) {
      if (!event.data) {
        return
      }
      this.truckingInfo = event.data
      this.setOldCarryingCmp()
      // 设置箱子信息
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        this.selectionChangeHandler({ data: this.truckingInfo })
      })
    },
    addHcInfoHandler() {
      this.addHcDoorHandler(true)
    },
    delHcInfoHandler() {
      if (!this.hcTruckingInfo) {
        return
      }
      const deleteList = this.trucking.filter(p => p.showTruckOrderNo === this.hcTruckingInfo.showTruckOrderNo)
      for (const ti of deleteList) {
        for (const usage of this.job.containerUsages) {
          if (usage.truckingInfoUuid === ti.uuid) {
            usage.truckingInfoUuid = null
          }
        }
        ti.jobUuid = null
        if (this.job.trucking.length > 0) {
          this.job.carryingCmp = this.trucking[0].carryingCmp
        } else {
          this.job.carryingCmp = 0
        }
        // 移除
        const index = this.trucking.indexOf(ti)
        if (ti.uuid && this.delTruckingInfoUuids.indexOf(ti.uuid) < 0) {
          this.delTruckingInfoUuids.push(ti.uuid)
        }
        if (index > -1) {
          this.deleteDoorPreHandle(ti)
          this.trucking.splice(index, 1)
        }
      }
      this.refreshInfo('', true)
    },
    addHcDoorHandler(top = false) {
      const trucking = new Trucking().fillDefaultValue().getData()
      this.setDefaultPortService(trucking)
      if (this.trucking.length === 0) {
        trucking.quantity = this.job.quantityActual
        trucking.weight = this.job.weightActual
        trucking.cubage = this.job.cubageActual
      }
      trucking.jobUuid = this.job.uuid
      // 新增的时候门点也清空
      trucking.doorName = ''
      trucking.doorMan = ''
      trucking.doorManTel = ''
      trucking.doorAddr = ''
      trucking.truckOrderNo = JobUtils.createTruckOrderNo(this.job)
      trucking.deliveryNo = 1
      if (top) {
        trucking.showTruckOrderNo = JobUtils.createShowTruckOrderNo(this.job, this.hcInfoTrucking)
      } else {
        trucking.showTruckOrderNo = this.hcTruckingInfo.showTruckOrderNo
        trucking.carryingCmp = this.hcTruckingInfo.carryingCmp
        trucking.plateNumber = this.hcTruckingInfo.plateNumber
        trucking.driver = this.hcTruckingInfo.driver
        trucking.driverTel = this.hcTruckingInfo.driverTel
        trucking.driverPhone = this.hcTruckingInfo.driverPhone
        trucking.truckingFee = this.hcTruckingInfo.truckingFee
        trucking.remarkItems = this.hcTruckingInfo.remarkItems
        trucking.soNo = this.hcTruckingInfo.soNo
        const hcDoorTrucking = this.trucking.filter(p => p.showTruckOrderNo === trucking.showTruckOrderNo)
        if (hcDoorTrucking && hcDoorTrucking.length > 0) {
          trucking.deliveryNo = hcDoorTrucking.length + 1
        }
      }
      this.trucking.push(trucking)
      if (top) {
        this.hcTruckingInfo = trucking
      }
      this.truckingInfo = trucking
      this.setOldCarryingCmp()
      this.refreshInfo(trucking.showTruckOrderNo, false)
    },
    delHcDoorHandler() {
      const showTruckOrderNo = this.truckingInfo.showTruckOrderNo
      // 去掉装箱信息和门点的关联（移至后端处理）
      for (const usage of this.job.containerUsages) {
        if (usage.truckingInfoUuid === this.truckingInfo.uuid) {
          usage.truckingInfoUuid = null
        }
      }
      this.truckingInfo.jobUuid = null
      if (this.job.trucking.length > 0) {
        this.job.carryingCmp = this.trucking[0].carryingCmp
      } else {
        this.job.carryingCmp = 0
      }
      // 移除
      const index = this.trucking.indexOf(this.truckingInfo)
      if (this.truckingInfo.uuid && this.delTruckingInfoUuids.indexOf(this.truckingInfo.uuid) < 0) {
        this.delTruckingInfoUuids.push(this.truckingInfo.uuid)
      }
      if (index > -1) {
        this.deleteDoorPreHandle(this.truckingInfo)
        this.trucking.splice(index, 1)
      }
      this.refreshInfo(showTruckOrderNo, true)
    },
    deleteDoorPreHandle(truckingInfo) {
      if (this.modifyUsageInEditMode && truckingInfo.usages && truckingInfo.usages.length > 0) {
        const uuids = []
        const tempUuids = []
        truckingInfo.usages.forEach(p => {
          p.bindedTrucking = false
          if (p.uuid) {
            uuids.push(p.uuid)
          } else {
            tempUuids.push(p.tempUuid)
          }
        })
        this.unBindContainerUsageUuids.push(...uuids)
      }
    },
    // 信息补充
    informationSupplementHandle(uuid, tempUuid) {
      if (!this.isEdit) {
        return
      }
      this.currentHcDoorTrucking = this.hcDoorTrucking.find(p => (!!uuid && p.uuid === uuid) || (!!tempUuid && p.tempUuid === tempUuid))
      const row = deepClone(this.currentHcDoorTrucking)
      if (!this.job.customerId || this.job.customerId === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCommissioningUnit'))
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      this.informationDialog.site = {
        companyUuid: companyUuid,
        companyName: this.$store.getters.language === 'zh' ? companyCache.chineseName : companyCache.englishName,
        country: 'CN',
        name: row.doorName || '',
        contact: row.doorMan || '',
        phone: row.doorManTel || '',
        province: row.province || '',
        cityNew: row.cityNew || '',
        county: row.county || '',
        town: row.town || '',
        cityNewStr: row.cityNewStr || '',
        countyStr: row.countyStr || '',
        townStr: row.townStr || '',
        address: row.doorAddr || '',
        provinceDisabled: !!row.province,
        cityNewDisabled: !!row.cityNewStr,
        countyDisabled: !!row.countyStr,
        townDisabled: !!row.townStr,
        addressDisabled: !!row.doorAddr,
        informationSupplement: true
      }
      this.informationDialog.title = this.$t('CargoMsg.CargoMsg_Information_Supplement')
      this.informationDialog.visible = true
    },
    syncSiteToJob(form) {
      this.currentHcDoorTrucking.doorName = form.name
      this.currentHcDoorTrucking.doorMan = form.contact
      this.currentHcDoorTrucking.doorManTel = form.phone
      this.currentHcDoorTrucking.province = form.province
      this.currentHcDoorTrucking.cityNewStr = form.cityNewStr
      this.currentHcDoorTrucking.countyStr = form.countyStr
      this.currentHcDoorTrucking.townStr = form.townStr
      this.currentHcDoorTrucking.cityNew = form.cityNew
      this.currentHcDoorTrucking.county = form.county
      this.currentHcDoorTrucking.town = form.town
      this.currentHcDoorTrucking.doorAddr = form.address
      this.hcDoor.gridApi.refreshCells({ force: true })
      this.refreshTruckingFee(this.currentHcDoorTrucking)
    },
    // 导入后数据处理
    uploadSuccessUsage(data) {
      this.loadTruckingRecord(this.truckingInfo)
    },
    // 门点信息弹框
    addDoor() {
      if (!this.job.customerId || this.job.customerId === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCommissioningUnit'))
        return
      }
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.customerId))
      if (!companyCache) return
      const companyUuid = companyCache.uuid
      if (!companyUuid) return
      this.addDoorDialog.form = {
        companyUuid: companyUuid,
        companyName: this.$store.getters.language === 'zh' ? companyCache.chineseName : companyCache.englishName
      }
      this.addDoorDialog.visible = true
    },
    setOldCarryingCmp() {
      this.oldCarryingCmp = this.truckingInfo ? this.truckingInfo.carryingCmp || 0 : 0
    }
  }

}
</script>
<style lang="scss">
.trucking-title-red {
  color: red;
  font-weight: bold
}
</style>
<style lang="scss" scoped>
.inline-form{
  margin-left: 20px;
  label{
    font-weight: normal;
  }
  .el-form-item__content{
    & > label{
      width: 40px;
      display: inline-block;
      &:first-of-type{
        margin-left: 1px;
      }
    }
    .el-input-number{
      width: 86px;
      margin-right: 10px;
    }
  }
  .el-form-item{
    &:nth-of-type(2){
      margin-left: 70px;
    }
    /deep/ .so-no-selector{
      & > span{
        &:first-of-type{
          flex: 1;
        }
      }
    }
  }
}
.trucking-form{
  width: 1200px;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .el-form{
    flex: 1;
    .el-form-item__content{
      & > label{
        margin: 0 10px;
        font-weight: normal;
      }
      span{
        &.currency{
          margin-left: 10px;
        }
      }
    }
    .plate_number{
      width: 280px;
      height: 28px;
      box-sizing: border-box;
      padding-left: 10px;
      vertical-align: middle;
      background-color: #f3f4f5;
      border: 1px solid #E4E7ED;
      color: blue;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }
    .vehicle-btn{
      margin-left: 10px;
    }
    .vehicle-tip{
      margin-left: 5px;
      font-size: 16px;
      color: #1F75D5;
    }
  }
}

</style>
